// This file is auto-generated by @hey-api/openapi-ts

import * as v from 'valibot';

export const vAvatarUpdatedDto = v.object({
  updated: v.boolean(),
});

export const vAvatarSourceDto = v.object({
  source: v.picklist(['provider', 'initials']),
});

export const vClientContractIssueDto = v.object({
  code: v.pipe(v.string(), v.maxLength(64)),
  path: v.pipe(v.string(), v.maxLength(256)),
});

export const vClientContractViolationDto = v.object({
  appVersion: v.pipe(v.string(), v.maxLength(128)),
  clientContractVersion: v.pipe(v.string(), v.maxLength(128)),
  apiContractVersion: v.nullable(v.pipe(v.string(), v.maxLength(128))),
  apiRevision: v.nullable(v.pipe(v.string(), v.maxLength(128))),
  method: v.pipe(v.string(), v.maxLength(16)),
  path: v.pipe(v.string(), v.maxLength(256)),
  status: v.nullable(v.pipe(v.number(), v.integer(), v.minValue(100), v.maxValue(599))),
  requestId: v.nullable(v.pipe(v.string(), v.maxLength(128))),
  issues: v.pipe(v.array(vClientContractIssueDto), v.minLength(1), v.maxLength(20)),
});

export const vApiErrorResponseDto = v.object({
  statusCode: v.pipe(v.number(), v.integer()),
  message: v.string(),
  error: v.optional(v.string()),
});

export const vHealthResponseDto = v.object({
  status: v.picklist(['ok']),
  service: v.picklist(['living-library-api']),
});

export const vReadinessResponseDto = v.object({
  status: v.picklist(['ok']),
  service: v.picklist(['living-library-api']),
  database: v.picklist(['connected', 'disabled']),
});

export const vIdentityResponseDto = v.object({
  provider: v.picklist(['workos']),
  subject: v.string(),
  sessionId: v.string(),
});

export const vAuthenticatedUserResponseDto = v.object({
  username: v.nullish(v.pipe(v.string(), v.maxLength(30))),
  avatarUrl: v.nullish(v.string()),
  avatarSource: v.optional(v.picklist(['provider', 'uploaded', 'initials'])),
  avatarHidden: v.optional(v.boolean()),
  displayName: v.nullable(v.pipe(v.string(), v.maxLength(120))),
  id: v.pipe(v.string(), v.uuid()),
  identity: vIdentityResponseDto,
});

export const vUsernameAvailabilityDto = v.object({
  available: v.boolean(),
  reason: v.nullable(v.string()),
});

export const vUpdateProfileRequestDto = v.object({
  username: v.optional(
    v.pipe(v.string(), v.minLength(3), v.maxLength(30), v.regex(/^[A-Za-z0-9._]{3,30}$/)),
  ),
  displayName: v.pipe(v.string(), v.minLength(1), v.maxLength(120)),
});

export const vReadingLanguagesDto = v.object({
  languages: v.pipe(v.array(v.string()), v.minLength(1), v.maxLength(12)),
});

export const vContentLanguagesDto = v.object({
  languages: v.pipe(v.array(v.string()), v.minLength(1), v.maxLength(12)),
});

export const vDeleteAccountRequestDto = v.object({
  confirmation: v.picklist(['DELETE']),
});

export const vFindAuthorSuggestionDto = v.object({
  ref: v.string(),
  name: v.string(),
  source: v.picklist(['nkp_skc', 'open_library', 'isbndb']),
  aliases: v.array(v.string()),
  exampleBook: v.nullable(v.string()),
});

export const vFindAuthorSuggestionsDto = v.object({
  items: v.array(vFindAuthorSuggestionDto),
  partial: v.boolean(),
});

export const vExternalRatingDistributionDto = v.object({
  oneStar: v.pipe(v.number(), v.integer(), v.minValue(0)),
  twoStars: v.pipe(v.number(), v.integer(), v.minValue(0)),
  threeStars: v.pipe(v.number(), v.integer(), v.minValue(0)),
  fourStars: v.pipe(v.number(), v.integer(), v.minValue(0)),
  fiveStars: v.pipe(v.number(), v.integer(), v.minValue(0)),
});

export const vExternalRatingDto = v.object({
  provider: v.picklist(['open_library']),
  subject: v.picklist(['book', 'author_books']),
  averageRating: v.nullable(v.pipe(v.number(), v.minValue(1), v.maxValue(5))),
  ratingCount: v.pipe(v.number(), v.integer(), v.minValue(0)),
  distribution: vExternalRatingDistributionDto,
  fetchedAt: v.pipe(v.string(), v.isoTimestamp()),
  sourceUrl: v.pipe(v.string(), v.url()),
});

export const vCatalogueContentModerationDto = v.object({
  cover: v.picklist(['visible', 'held', 'suppressed']),
  description: v.picklist(['visible', 'held', 'suppressed']),
});

export const vCatalogueContributionSummaryDto = v.object({
  submissionId: v.pipe(v.string(), v.uuid()),
  status: v.picklist([
    'pending',
    'changes_requested',
    'declined',
    'withdrawn',
    'published',
    'matched',
  ]),
  moderatorMessage: v.nullable(v.string()),
  createdAt: v.pipe(v.string(), v.isoTimestamp()),
  updatedAt: v.pipe(v.string(), v.isoTimestamp()),
});

export const vObalkyReviewDto = v.object({
  id: v.pipe(v.string(), v.maxLength(20)),
  text: v.pipe(v.string(), v.maxLength(1200)),
  attribution: v.nullable(v.pipe(v.string(), v.maxLength(160))),
  createdAt: v.nullable(v.string()),
});

export const vObalkyFeedbackDto = v.object({
  source: v.picklist(['obalkyknih']),
  sourceId: v.pipe(v.string(), v.maxLength(20)),
  sourceUrl: v.pipe(v.string(), v.maxLength(2048)),
  checkedAt: v.pipe(v.string(), v.isoTimestamp()),
  averageRating: v.nullable(v.pipe(v.number(), v.minValue(0), v.maxValue(5))),
  ratingCount: v.pipe(v.number(), v.integer(), v.minValue(0)),
  reviews: v.pipe(v.array(vObalkyReviewDto), v.maxLength(3)),
});

/**
 * Controlled, multi-label genres derived from bounded provider subjects. An empty or omitted array means no confident classification.
 */
export const vBookGenre = v.picklist([
  'fantasy',
  'science_fiction',
  'romance',
  'mystery_thriller',
  'horror',
  'historical_fiction',
  'literary_fiction',
  'adventure',
  'young_adult',
  'childrens',
  'biography_memoir',
  'history',
  'nonfiction',
  'poetry',
  'comics_graphic_novels',
]);

export const vLibraryBookDto = v.object({
  catalogueContentToken: v.optional(v.string()),
  contentModeration: v.optional(vCatalogueContentModerationDto),
  catalogStatus: v.optional(v.picklist(['verified', 'owner_scoped', 'rejected'])),
  catalogueVisibility: v.optional(v.picklist(['visible', 'hidden'])),
  metadataVersion: v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
  coverPolicy: v.optional(v.picklist(['automatic', 'moderator', 'none'])),
  metadataLocked: v.optional(v.boolean()),
  canSubmitForPublication: v.optional(v.boolean()),
  catalogueContribution: v.nullish(vCatalogueContributionSummaryDto),
  canReportCatalogue: v.optional(v.boolean()),
  obalkyFeedback: v.optional(vObalkyFeedbackDto),
  id: v.pipe(v.string(), v.uuid()),
  title: v.string(),
  subtitle: v.nullable(v.string()),
  description: v.nullable(v.pipe(v.string(), v.maxLength(12000))),
  genres: v.optional(v.pipe(v.array(vBookGenre), v.maxLength(15))),
  subjects: v.optional(v.pipe(v.array(v.string()), v.maxLength(64))),
  authors: v.array(v.string()),
  authorUnknown: v.optional(v.boolean()),
  binding: v.nullish(v.string()),
  language: v.nullable(v.string()),
  isbn10: v.nullable(v.string()),
  isbn13: v.nullable(v.string()),
  publisher: v.nullable(v.string()),
  publishedYear: v.nullable(v.pipe(v.number(), v.integer())),
  coverImageUrl: v.nullable(v.pipe(v.string(), v.url())),
  coverSource: v.nullable(v.string()),
  coverSourceId: v.nullable(v.string()),
  coverRightsNote: v.nullable(v.string()),
  pageCount: v.nullable(v.pipe(v.number(), v.integer(), v.minValue(1))),
  source: v.nullable(v.string()),
  sourceId: v.nullable(v.string()),
  sourceUrl: v.nullable(v.pipe(v.string(), v.url())),
  isTransient: v.optional(v.boolean()),
});

export const vAuthorProfileDto = v.object({
  id: v.string(),
  name: v.string(),
  alternateNames: v.array(v.string()),
  bio: v.nullable(v.pipe(v.string(), v.maxLength(12000))),
  birthDate: v.nullable(v.string()),
  photoUrl: v.nullable(v.pipe(v.string(), v.url())),
  photoRightsNote: v.nullable(v.string()),
  websiteUrl: v.nullable(v.pipe(v.string(), v.url())),
  sourceUrl: v.pipe(v.string(), v.url()),
  externalRating: v.nullable(vExternalRatingDto),
  books: v.array(vLibraryBookDto),
});

export const vCreateCustomBookRequestDto = v.object({
  clientRequestId: v.pipe(v.string(), v.uuid()),
  title: v.pipe(v.string(), v.minLength(1), v.maxLength(1000)),
  subtitle: v.nullish(v.pipe(v.string(), v.maxLength(2000))),
  authors: v.pipe(v.array(v.string()), v.maxLength(16)),
  authorUnknown: v.optional(v.boolean(), false),
  isbn: v.nullish(v.pipe(v.string(), v.maxLength(32))),
  language: v.nullish(v.string()),
  pageCount: v.nullish(v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(10000))),
  genres: v.optional(v.pipe(v.array(vBookGenre), v.maxLength(15))),
  binding: v.optional(v.picklist(['paperback', 'hardcover', 'ebook', 'other'])),
  publisher: v.nullish(v.pipe(v.string(), v.maxLength(1000))),
  publishedYear: v.nullish(v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(9999))),
  status: v.optional(
    v.picklist(['to_be_read', 'currently_reading', 'already_read', 'did_not_finish']),
    'to_be_read',
  ),
  finishedOn: v.nullish(v.pipe(v.string(), v.isoDate())),
});

export const vUserBookRelationDto = v.object({
  lastReadingLoggedAt: v.nullish(v.pipe(v.string(), v.isoTimestamp())),
  personalGenres: v.optional(v.pipe(v.array(vBookGenre), v.maxLength(15))),
  id: v.pipe(v.string(), v.uuid()),
  isFocused: v.boolean(),
  status: v.picklist(['to_be_read', 'currently_reading', 'already_read', 'did_not_finish']),
  currentPage: v.pipe(v.number(), v.integer(), v.minValue(0)),
  personalPageCount: v.nullable(v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(10000))),
  startedAt: v.nullable(v.pipe(v.string(), v.isoTimestamp())),
  finishedAt: v.nullable(v.pipe(v.string(), v.isoTimestamp())),
  updatedAt: v.pipe(v.string(), v.isoTimestamp()),
  book: vLibraryBookDto,
});

export const vCustomBookConflictResponseDto = v.object({
  statusCode: v.pipe(v.number(), v.integer()),
  message: v.string(),
  error: v.optional(v.string()),
  bookId: v.optional(v.pipe(v.string(), v.uuid())),
});

export const vCatalogueAuthorSuggestionDto = v.object({
  id: v.pipe(v.string(), v.uuid()),
  name: v.string(),
});

export const vCatalogueAuthorSuggestionsDto = v.object({
  items: v.pipe(v.array(vCatalogueAuthorSuggestionDto), v.maxLength(10)),
});

export const vChamberResponseDto = v.object({
  currentReading: v.nullable(vUserBookRelationDto),
  toBeRead: v.array(vUserBookRelationDto),
});

export const vBookSearchResponseDto = v.object({
  widerSearchCursor: v.nullish(v.string()),
  nextCursor: v.nullish(v.string()),
  hasMore: v.optional(v.boolean()),
  limitReached: v.optional(v.boolean()),
  query: v.pipe(v.string(), v.maxLength(120)),
  items: v.array(vLibraryBookDto),
  widerSearchAvailable: v.boolean(),
  widerSearchUsed: v.boolean(),
});

export const vResolveBookByIsbnRequestDto = v.object({
  isbn: v.pipe(v.string(), v.maxLength(32)),
  source: v.optional(
    v.picklist(['google_books', 'isbndb', 'knihovny_cz', 'open_library', 'nkp_skc']),
  ),
  sourceId: v.optional(v.pipe(v.string(), v.minLength(1), v.maxLength(500))),
});

export const vBookEditionOptionDto = v.object({
  source: v.optional(v.picklist(['open_library', 'nkp_skc'])),
  bookId: v.optional(v.pipe(v.string(), v.uuid())),
  authors: v.optional(v.array(v.string())),
  coverSource: v.nullish(v.string()),
  coverRightsNote: v.nullish(v.string()),
  coverImageUrl: v.nullable(v.pipe(v.string(), v.url())),
  coverSourceId: v.nullable(v.string()),
  isbn10: v.nullable(v.string()),
  isbn13: v.nullable(v.string()),
  language: v.nullable(v.string()),
  isCurrentEdition: v.boolean(),
  pageCount: v.nullable(v.pipe(v.number(), v.integer(), v.minValue(1))),
  publishDate: v.nullable(v.string()),
  publishedYear: v.nullable(v.pipe(v.number(), v.integer())),
  publisher: v.nullable(v.string()),
  sourceId: v.pipe(v.string(), v.regex(/^(OL[0-9]+M|[0-9]{1,32})$/)),
  sourceUrl: v.pipe(v.string(), v.url()),
  subtitle: v.nullable(v.string()),
  title: v.string(),
});

export const vBookEditionsResponseDto = v.object({
  totalCountExact: v.optional(v.boolean()),
  items: v.pipe(v.array(vBookEditionOptionDto), v.maxLength(1020)),
  nextOffset: v.nullable(v.pipe(v.number(), v.integer(), v.minValue(0))),
  openLibraryWorkId: v.nullable(v.pipe(v.string(), v.regex(/^OL[0-9]+W$/))),
  sourceUrl: v.nullable(v.pipe(v.string(), v.url())),
  totalCount: v.pipe(v.number(), v.integer(), v.minValue(0)),
});

export const vReadingStatus = v.picklist([
  'to_be_read',
  'currently_reading',
  'already_read',
  'did_not_finish',
]);

export const vUserLibraryResponseDto = v.object({
  items: v.array(vUserBookRelationDto),
});

export const vReadingAttemptDto = v.object({
  id: v.pipe(v.string(), v.uuid()),
  ordinal: v.pipe(v.number(), v.integer(), v.minValue(1)),
  outcome: v.picklist(['active', 'completed', 'did_not_finish', 'stopped']),
  startedAt: v.nullable(v.pipe(v.string(), v.isoTimestamp())),
  startedOn: v.nullable(v.pipe(v.string(), v.isoDate())),
  firstProgressAt: v.nullable(v.pipe(v.string(), v.isoTimestamp())),
  finishedAt: v.nullable(v.pipe(v.string(), v.isoTimestamp())),
  finishedOn: v.nullable(v.string()),
  startPage: v.pipe(v.number(), v.integer(), v.minValue(0)),
  endPage: v.pipe(v.number(), v.integer(), v.minValue(0)),
  pageCountSnapshot: v.nullable(v.pipe(v.number(), v.integer(), v.minValue(1))),
  source: v.pipe(v.string(), v.maxLength(64)),
  createdAt: v.pipe(v.string(), v.isoTimestamp()),
  updatedAt: v.pipe(v.string(), v.isoTimestamp()),
});

export const vReadingStatusEventDto = v.object({
  id: v.pipe(v.string(), v.uuid()),
  attemptId: v.nullable(v.pipe(v.string(), v.uuid())),
  fromStatus: v.picklist(['to_be_read', 'currently_reading', 'already_read', 'did_not_finish']),
  toStatus: v.picklist(['to_be_read', 'currently_reading', 'already_read', 'did_not_finish']),
  occurredAt: v.pipe(v.string(), v.isoTimestamp()),
  source: v.pipe(v.string(), v.maxLength(64)),
});

export const vReadingProgressEventDto = v.object({
  id: v.pipe(v.string(), v.uuid()),
  attemptId: v.nullable(v.pipe(v.string(), v.uuid())),
  fromPage: v.pipe(v.number(), v.integer(), v.minValue(0)),
  toPage: v.pipe(v.number(), v.integer(), v.minValue(0)),
  pageCountSnapshot: v.nullable(v.pipe(v.number(), v.integer(), v.minValue(1))),
  direction: v.picklist(['forward', 'correction']),
  occurredAt: v.pipe(v.string(), v.isoTimestamp()),
  source: v.pipe(v.string(), v.maxLength(64)),
});

export const vReadingSessionDto = v.object({
  activityOn: v.pipe(v.string(), v.isoDate()),
  id: v.pipe(v.string(), v.uuid()),
  attemptId: v.pipe(v.string(), v.uuid()),
  progressEventId: v.nullable(v.pipe(v.string(), v.uuid())),
  startedAt: v.nullable(v.pipe(v.string(), v.isoTimestamp())),
  endedAt: v.nullable(v.pipe(v.string(), v.isoTimestamp())),
  loggedAt: v.pipe(v.string(), v.isoTimestamp()),
  startPage: v.pipe(v.number(), v.integer(), v.minValue(0)),
  endPage: v.pipe(v.number(), v.integer(), v.minValue(1)),
  pagesRead: v.pipe(v.number(), v.integer(), v.minValue(1)),
  durationSeconds: v.nullable(v.pipe(v.number(), v.integer(), v.minValue(0))),
  captureMethod: v.picklist(['progress_log', 'timer', 'manual_session', 'import']),
  source: v.pipe(v.string(), v.maxLength(64)),
});

export const vReadingHistoryResponseDto = v.object({
  relationId: v.pipe(v.string(), v.uuid()),
  sourceAddedOn: v.nullable(v.pipe(v.string(), v.isoDate())),
  lastReadOn: v.nullable(v.pipe(v.string(), v.isoDate())),
  importedReadCount: v.nullable(v.pipe(v.number(), v.integer(), v.minValue(0))),
  ownedCopies: v.nullable(v.pipe(v.number(), v.integer(), v.minValue(0))),
  attempts: v.array(vReadingAttemptDto),
  statusEvents: v.array(vReadingStatusEventDto),
  progressEvents: v.array(vReadingProgressEventDto),
  sessions: v.array(vReadingSessionDto),
  attemptsHasMore: v.boolean(),
  statusEventsHasMore: v.boolean(),
  progressEventsHasMore: v.boolean(),
  sessionsHasMore: v.boolean(),
});

export const vRemoveUserBookRelationResponseDto = v.object({
  removed: v.literal(true),
});

export const vReadingCompletionInputDto = v.object({
  mode: v.picklist(['today', 'past']),
  timeZone: v.string(),
  finishedOn: v.nullish(v.string()),
});

export const vUpsertUserBookRequestDto = v.object({
  completion: v.optional(vReadingCompletionInputDto),
  bookId: v.pipe(v.string(), v.uuid()),
  status: v.picklist(['to_be_read', 'currently_reading', 'already_read', 'did_not_finish']),
  eventId: v.optional(v.pipe(v.string(), v.uuid())),
});

export const vUpdateUserBookRequestDto = v.object({
  completion: v.optional(vReadingCompletionInputDto),
  status: v.picklist(['to_be_read', 'currently_reading', 'already_read', 'did_not_finish']),
  eventId: v.optional(v.pipe(v.string(), v.uuid())),
});

export const vUpdateReadingProgressRequestDto = v.object({
  currentPage: v.pipe(v.number(), v.integer(), v.minValue(0)),
  eventId: v.optional(v.pipe(v.string(), v.uuid())),
  occurredAt: v.optional(v.pipe(v.string(), v.isoTimestamp())),
});

export const vUpdatePersonalPageCountRequestDto = v.object({
  personalPageCount: v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(10000)),
});

export const vCommunityPublicPostingDto = v.object({
  allowed: v.boolean(),
  restrictedUntil: v.nullable(v.pipe(v.string(), v.isoTimestamp())),
});

export const vCommunityStatusDto = v.object({
  termsVersion: v.string(),
  acceptedTermsVersion: v.nullable(v.string()),
  acceptedAt: v.nullable(v.pipe(v.string(), v.isoTimestamp())),
  termsAccepted: v.boolean(),
  publicPosting: vCommunityPublicPostingDto,
});

export const vAcceptCommunityTermsRequestDto = v.object({
  termsVersion: v.string(),
});

/**
 * content reports this item; reader reports its author profile identity (name, nickname, photo).
 */
export const vCommunityReportSubject = v.picklist(['content', 'reader']);

export const vCommunityContentKind = v.picklist(['review', 'thought', 'line']);

export const vCommunityContentRefDto = v.object({
  kind: vCommunityContentKind,
  id: v.pipe(v.string(), v.uuid()),
});

export const vCommunityReportReason = v.picklist([
  'spam',
  'harassment',
  'sexual_or_violent',
  'spoilers',
  'other',
]);

export const vCreateCommunityReportRequestDto = v.object({
  clientRequestId: v.pipe(v.string(), v.uuid()),
  subject: vCommunityReportSubject,
  content: vCommunityContentRefDto,
  reason: vCommunityReportReason,
  note: v.optional(v.pipe(v.string(), v.maxLength(1000))),
});

export const vCommunityReportReceiptDto = v.object({
  id: v.pipe(v.string(), v.uuid()),
  subject: vCommunityReportSubject,
  duplicate: v.boolean(),
  hiddenForReporter: v.boolean(),
});

export const vBlockedReaderDto = v.object({
  userId: v.pipe(v.string(), v.uuid()),
  name: v.nullable(v.string()),
  username: v.nullable(v.string()),
  avatarUrl: v.nullable(v.string()),
  blockedAt: v.pipe(v.string(), v.isoTimestamp()),
});

export const vBlockedReadersDto = v.object({
  items: v.array(vBlockedReaderDto),
});

export const vCommunityAuthoredContentKind = v.picklist(['review', 'thought']);

export const vCommunityAuthoredContentRefDto = v.object({
  kind: vCommunityAuthoredContentKind,
  id: v.pipe(v.string(), v.uuid()),
});

export const vBlockReaderRequestDto = v.object({
  content: vCommunityAuthoredContentRefDto,
});

export const vBlockReaderResponseDto = v.object({
  reader: vBlockedReaderDto,
});

export const vUnblockReaderResponseDto = v.object({
  unblocked: v.boolean(),
});

export const vCollectibleEntitlementDto = v.object({
  collectibleId: v.pipe(v.string(), v.minLength(1), v.maxLength(160)),
  collectibleType: v.picklist(['badge', 'theme_pack', 'plant', 'pot']),
  grantId: v.pipe(v.string(), v.uuid()),
  grantedAt: v.pipe(v.string(), v.isoTimestamp()),
});

export const vGoalProgressAttemptDto = v.object({
  activityDates: v.optional(v.pipe(v.array(v.string()), v.maxLength(3))),
  finishedOn: v.nullish(v.string()),
  ratingValue: v.nullish(v.pipe(v.number(), v.minValue(0), v.maxValue(5))),
  attemptId: v.pipe(v.string(), v.uuid()),
  completable: v.boolean(),
  current: v.pipe(v.number(), v.integer(), v.minValue(0)),
  state: v.picklist(['active', 'closed']),
  target: v.pipe(v.number(), v.integer(), v.minValue(1)),
  userBookId: v.pipe(v.string(), v.uuid()),
});

export const vGoalProgressDimensionDto = v.object({
  current: v.pipe(v.number(), v.integer(), v.minValue(0)),
  id: v.pipe(v.string(), v.minLength(1), v.maxLength(80)),
  target: v.pipe(v.number(), v.integer(), v.minValue(1)),
  unit: v.picklist([
    'books',
    'count',
    'days',
    'genres',
    'ratings',
    'reviews',
    'sessions',
    'weeks',
    'works',
  ]),
});

export const vGoalProgressStepDto = v.object({
  completed: v.boolean(),
  id: v.pipe(v.string(), v.minLength(1), v.maxLength(80)),
});

export const vGoalProgressDto = v.object({
  selectedUserBookId: v.optional(v.pipe(v.string(), v.uuid())),
  activeAttempt: v.optional(vGoalProgressAttemptDto),
  current: v.pipe(v.number(), v.integer(), v.minValue(0)),
  dimensions: v.optional(v.array(vGoalProgressDimensionDto)),
  historicalBestAttempt: v.optional(vGoalProgressAttemptDto),
  selectedAttempt: v.optional(vGoalProgressAttemptDto),
  steps: v.optional(v.array(vGoalProgressStepDto)),
  target: v.pipe(v.number(), v.integer(), v.minValue(1)),
  unit: v.picklist([
    'books',
    'count',
    'days',
    'genres',
    'ratings',
    'reviews',
    'sessions',
    'steps',
    'works',
  ]),
});

export const vGoalRecommendationDto = v.object({
  near: v.boolean(),
});

export const vAchievementLocalizedTextDto = v.object({
  en: v.pipe(v.string(), v.minLength(1), v.maxLength(2000)),
  sk: v.pipe(v.string(), v.minLength(1), v.maxLength(2000)),
  cs: v.pipe(v.string(), v.minLength(1), v.maxLength(2000)),
});

export const vAchievementStepPresentationDto = v.object({
  id: v.pipe(v.string(), v.minLength(1), v.maxLength(80)),
  title: vAchievementLocalizedTextDto,
  shortTitle: vAchievementLocalizedTextDto,
  action: v.pipe(v.string(), v.maxLength(80)),
  evidence: v.pipe(v.string(), v.maxLength(80)),
});

export const vAchievementDimensionPresentationDto = v.object({
  id: v.pipe(v.string(), v.minLength(1), v.maxLength(80)),
  title: vAchievementLocalizedTextDto,
});

export const vAchievementPresentationDto = v.object({
  version: v.pipe(v.number(), v.integer(), v.minValue(1)),
  title: vAchievementLocalizedTextDto,
  description: vAchievementLocalizedTextDto,
  groupId: v.pipe(v.string(), v.minLength(1), v.maxLength(80)),
  groupTitle: vAchievementLocalizedTextDto,
  layout: v.pipe(v.string(), v.maxLength(80)),
  readingSelection: v.boolean(),
  steps: v.pipe(v.array(vAchievementStepPresentationDto), v.maxLength(32)),
  dimensions: v.optional(v.pipe(v.array(vAchievementDimensionPresentationDto), v.maxLength(32))),
  eyebrow: v.optional(vAchievementLocalizedTextDto),
  artworkUrl: v.optional(v.pipe(v.string(), v.maxLength(2048), v.regex(/^https:\/\//))),
});

export const vSelectAchievementReadingRequestDto = v.object({
  userBookId: v.pipe(v.string(), v.uuid()),
});

export const vNoGoalRewardDto = v.object({
  kind: v.picklist(['none']),
});

export const vBadgeGoalRewardDto = v.object({
  collectibleId: v.pipe(v.string(), v.minLength(1), v.maxLength(160)),
  kind: v.picklist(['badge']),
});

export const vThemePackGoalRewardDto = v.object({
  collectibleId: v.pipe(v.string(), v.minLength(1), v.maxLength(160)),
  kind: v.picklist(['theme_pack']),
});

export const vLibraryItemGoalRewardDto = v.object({
  collectibleId: v.pipe(v.string(), v.minLength(1), v.maxLength(160)),
  kind: v.picklist(['plant', 'pot']),
});

export const vCatalogueGoalStateDto = v.object({
  category: v.picklist(['library', 'journey', 'reflection']),
  criteriaVersion: v.pipe(v.number(), v.integer(), v.minValue(1)),
  displayOrder: v.pipe(v.number(), v.integer(), v.minValue(0)),
  earnedCriteriaVersion: v.nullable(v.pipe(v.number(), v.integer(), v.minValue(1))),
  progress: vGoalProgressDto,
  recommendation: vGoalRecommendationDto,
  reward: v.union([
    vNoGoalRewardDto,
    vBadgeGoalRewardDto,
    vThemePackGoalRewardDto,
    vLibraryItemGoalRewardDto,
  ]),
  unlockedAt: v.nullable(v.pipe(v.string(), v.isoTimestamp())),
  id: v.pipe(v.string(), v.maxLength(80), v.regex(/^[a-z][a-z0-9_]{0,79}$/)),
  presentation: vAchievementPresentationDto,
});

export const vReaderAchievementCatalogueStateDto = v.object({
  collectibleEntitlements: v.array(vCollectibleEntitlementDto),
  evaluatedAt: v.pipe(v.string(), v.isoTimestamp()),
  goals: v.array(vCatalogueGoalStateDto),
  schemaVersion: v.picklist(['achievement-state-v3']),
});

export const vAuthoritativeGoalStateDto = v.object({
  category: v.picklist(['library', 'journey', 'reflection']),
  criteriaVersion: v.pipe(v.number(), v.integer(), v.minValue(1)),
  displayOrder: v.pipe(v.number(), v.integer(), v.minValue(0)),
  earnedCriteriaVersion: v.nullable(v.pipe(v.number(), v.integer(), v.minValue(1))),
  id: v.picklist([
    'first_shelf',
    'first_read',
    'personal_archive',
    'second_genre',
    'five_worlds',
    'first_bookmark',
    'between_bookmarks',
    'reading_rhythm',
    'cover_to_cover',
    'another_story',
    'reading_ritual',
    'first_impression',
    'afterword',
  ]),
  progress: vGoalProgressDto,
  recommendation: vGoalRecommendationDto,
  reward: v.union([
    vNoGoalRewardDto,
    vBadgeGoalRewardDto,
    vThemePackGoalRewardDto,
    vLibraryItemGoalRewardDto,
  ]),
  unlockedAt: v.nullable(v.pipe(v.string(), v.isoTimestamp())),
});

export const vReaderAchievementStateDto = v.object({
  collectibleEntitlements: v.array(vCollectibleEntitlementDto),
  evaluatedAt: v.pipe(v.string(), v.isoTimestamp()),
  goals: v.array(vAuthoritativeGoalStateDto),
  schemaVersion: v.picklist(['achievement-state-v2']),
});

export const vLocalizedText = v.object({
  sk: v.pipe(v.string(), v.maxLength(2000)),
  cs: v.pipe(v.string(), v.maxLength(2000)),
  en: v.pipe(v.string(), v.maxLength(2000)),
});

export const vAdminBoardPickDto = v.object({
  id: v.string(),
  workId: v.string(),
  reason: vLocalizedText,
});

export const vAdminBoardOptionDto = v.object({
  id: v.string(),
  workId: v.string(),
});

export const vAdminBoardQuestionDto = v.object({
  id: v.string(),
  prompt: vLocalizedText,
  options: v.array(vAdminBoardOptionDto),
});

export const vBoardOptionCountDto = v.object({
  optionId: v.string(),
  count: v.number(),
});

export const vBoardValidationIssueDto = v.object({
  field: v.string(),
  language: v.nullable(v.string()),
  message: v.string(),
});

export const vAdminBoardEditorialDto = v.object({
  expectedVersion: v.number(),
  period: v.nullable(v.string()),
  startsAt: v.nullable(v.string()),
  endsAt: v.nullable(v.string()),
  hostId: v.nullable(v.string()),
  title: vLocalizedText,
  intro: vLocalizedText,
  items: v.array(vAdminBoardPickDto),
  questions: v.array(vAdminBoardQuestionDto),
  id: v.string(),
  kind: v.picklist(['picks', 'quiz']),
  status: v.picklist(['draft', 'scheduled', 'published', 'archived', 'active', 'ended']),
  publishAt: v.nullable(v.string()),
  answerCount: v.number(),
  hasVotes: v.boolean(),
  counts: v.array(vBoardOptionCountDto),
  issues: v.array(vBoardValidationIssueDto),
});

export const vSaveBoardEditorialRequestDto = v.object({
  expectedVersion: v.number(),
  period: v.nullable(v.string()),
  startsAt: v.nullable(v.string()),
  endsAt: v.nullable(v.string()),
  hostId: v.nullable(v.string()),
  title: vLocalizedText,
  intro: vLocalizedText,
  items: v.array(vAdminBoardPickDto),
  questions: v.array(vAdminBoardQuestionDto),
});

export const vBoardEditorialActionRequestDto = v.object({
  expectedVersion: v.number(),
  action: v.picklist(['publish', 'schedule', 'archive', 'end', 'draft']),
  publishAt: v.nullable(v.string()),
});

export const vResolveBoardWorkRequestDto = v.object({
  bookId: v.optional(v.string()),
  isbn: v.optional(v.string()),
  source: v.optional(v.picklist(['open_library', 'isbndb', 'nkp_skc'])),
  sourceId: v.optional(v.string()),
});

export const vBoardBookDto = v.object({
  catalogueContentToken: v.optional(v.string()),
  contentModeration: v.optional(vCatalogueContentModerationDto),
  catalogStatus: v.optional(v.picklist(['verified', 'owner_scoped', 'rejected'])),
  catalogueVisibility: v.optional(v.picklist(['visible', 'hidden'])),
  metadataVersion: v.optional(v.pipe(v.number(), v.integer(), v.minValue(1))),
  coverPolicy: v.optional(v.picklist(['automatic', 'moderator', 'none'])),
  metadataLocked: v.optional(v.boolean()),
  canSubmitForPublication: v.optional(v.boolean()),
  catalogueContribution: v.nullish(vCatalogueContributionSummaryDto),
  canReportCatalogue: v.optional(v.boolean()),
  obalkyFeedback: v.optional(vObalkyFeedbackDto),
  id: v.pipe(v.string(), v.uuid()),
  title: v.string(),
  subtitle: v.nullable(v.string()),
  description: v.nullable(v.pipe(v.string(), v.maxLength(12000))),
  genres: v.optional(v.pipe(v.array(vBookGenre), v.maxLength(15))),
  subjects: v.optional(v.pipe(v.array(v.string()), v.maxLength(64))),
  authors: v.array(v.string()),
  authorUnknown: v.optional(v.boolean()),
  binding: v.nullish(v.string()),
  language: v.nullable(v.string()),
  isbn10: v.nullable(v.string()),
  isbn13: v.nullable(v.string()),
  publisher: v.nullable(v.string()),
  publishedYear: v.nullable(v.pipe(v.number(), v.integer())),
  coverImageUrl: v.nullable(v.pipe(v.string(), v.url())),
  coverSource: v.nullable(v.string()),
  coverSourceId: v.nullable(v.string()),
  coverRightsNote: v.nullable(v.string()),
  pageCount: v.nullable(v.pipe(v.number(), v.integer(), v.minValue(1))),
  source: v.nullable(v.string()),
  sourceId: v.nullable(v.string()),
  sourceUrl: v.nullable(v.pipe(v.string(), v.url())),
  isTransient: v.optional(v.boolean()),
});

export const vBoardWorkEditionsDto = v.object({
  sk: v.nullable(vBoardBookDto),
  cs: v.nullable(vBoardBookDto),
  en: v.nullable(vBoardBookDto),
});

export const vAdminBoardWorkDto = v.object({
  id: v.string(),
  editions: vBoardWorkEditionsDto,
  missingLanguages: v.array(v.string()),
});

export const vAdminBoardTeamDto = v.object({
  id: v.string(),
  displayName: v.string(),
  avatarUrl: v.nullable(v.string()),
  enabled: v.boolean(),
  role: vLocalizedText,
});

export const vUpdateBoardTeamRequestDto = v.object({
  enabled: v.boolean(),
  role: vLocalizedText,
});

export const vBoardModerationItemDto = v.object({
  kind: v.picklist(['review', 'line', 'team_book']),
  id: v.string(),
  label: v.string(),
  hiddenBy: v.nullable(v.string()),
  hiddenAt: v.nullable(v.string()),
});

export const vUpdateBoardVisibilityRequestDto = v.object({
  hidden: v.boolean(),
});

export const vBoardMonthSummaryDto = v.object({
  month: v.string(),
  pagesRead: v.number(),
  booksFinished: v.number(),
  finishedBooks: v.array(vBoardBookDto),
  goalWeeksMet: v.nullable(v.number()),
  goalWeeksTotal: v.nullable(v.number()),
});

export const vBoardMonthPresentation = v.picklist(['full', 'compact', 'new_reader']);

export const vBoardPickDto = v.object({
  book: vBoardBookDto,
  reason: v.pipe(v.string(), v.maxLength(80)),
  viewerStatus: v.nullable(vReadingStatus),
});

export const vBoardTeamMemberDto = v.object({
  id: v.string(),
  displayName: v.string(),
  avatarUrl: v.nullable(v.string()),
});

export const vBoardPicksDto = v.object({
  id: v.string(),
  period: v.string(),
  totalCount: v.number(),
  items: v.array(vBoardPickDto),
  curator: v.nullable(vBoardTeamMemberDto),
});

export const vBoardQuizResultOptionDto = v.object({
  id: v.string(),
  book: vBoardBookDto,
  percent: v.nullable(v.number()),
  viewerChoice: v.boolean(),
});

export const vBoardQuizTeaserDto = v.object({
  id: v.string(),
  prompt: v.string(),
  books: v.array(vBoardBookDto),
  options: v.array(vBoardQuizResultOptionDto),
});

export const vBoardQuizViewerStatus = v.picklist(['not_started', 'in_progress', 'answered']);

export const vBoardQuizCardDto = v.object({
  id: v.string(),
  title: v.string(),
  endsAt: v.string(),
  host: vBoardTeamMemberDto,
  questionCount: v.number(),
  firstQuestion: vBoardQuizTeaserDto,
  answerCount: v.number(),
  resultsAvailable: v.boolean(),
  viewerStatus: vBoardQuizViewerStatus,
});

export const vBoardRecentQuizOptionDto = v.object({
  id: v.string(),
  book: vBoardBookDto,
  percent: v.nullable(v.number()),
  viewerChoice: v.boolean(),
  isWinner: v.boolean(),
});

export const vBoardRecentQuizQuestionDto = v.object({
  questionId: v.string(),
  prompt: v.string(),
  options: v.array(vBoardRecentQuizOptionDto),
});

export const vBoardRecentQuizDto = v.object({
  id: v.string(),
  title: v.string(),
  endedAt: v.string(),
  answerCount: v.number(),
  resultsAvailable: v.boolean(),
  winners: v.array(vBoardRecentQuizQuestionDto),
});

export const vBoardChartItemDto = v.object({
  rank: v.pipe(v.number(), v.minValue(0)),
  book: vBoardBookDto,
  readerCount: v.number(),
  viewerStatus: v.nullable(vReadingStatus),
});

export const vBoardChartDto = v.object({
  windowStart: v.string(),
  windowEnd: v.string(),
  totalCount: v.number(),
  items: v.array(vBoardChartItemDto),
});

export const vTextLanguageSource = v.picklist(['detected', 'user', 'undetermined']);

export const vTextLanguageDto = v.object({
  language: v.nullable(v.pipe(v.string(), v.maxLength(35))),
  source: vTextLanguageSource,
  confidence: v.nullable(v.pipe(v.number(), v.minValue(0), v.maxValue(1))),
  detector: v.nullable(v.picklist(['apple', 'mlkit'])),
});

export const vPublicThoughtDto = v.object({
  textLanguage: v.optional(vTextLanguageDto),
  id: v.pipe(v.string(), v.uuid()),
  body: v.string(),
  readerAvatarUrl: v.nullish(v.string()),
  readerName: v.nullable(v.string()),
  publishedAt: v.pipe(v.string(), v.isoTimestamp()),
  isMine: v.boolean(),
  containsSpoilers: v.boolean(),
  beyondYourPosition: v.boolean(),
  likeCount: v.pipe(v.number(), v.integer(), v.minValue(0)),
  viewerHasLiked: v.boolean(),
});

export const vPublicLineDto = v.object({
  id: v.pipe(v.string(), v.uuid()),
  variantId: v.pipe(v.string(), v.uuid()),
  body: v.string(),
  language: v.string(),
  readerCount: v.pipe(v.number(), v.integer(), v.minValue(1)),
  likeCount: v.pipe(v.number(), v.integer(), v.minValue(0)),
  viewerHasLiked: v.boolean(),
  viewerQuoteId: v.nullable(v.pipe(v.string(), v.uuid())),
  pageNumber: v.nullable(v.pipe(v.number(), v.integer())),
  approximatePage: v.boolean(),
  currentPage: v.nullable(v.pipe(v.number(), v.integer())),
  beyondYourPosition: v.boolean(),
  thoughtCount: v.pipe(v.number(), v.integer(), v.minValue(0)),
  thoughts: v.array(vPublicThoughtDto),
});

export const vBoardLineItemDto = v.object({
  book: vBoardBookDto,
  line: vPublicLineDto,
  savesThisWeek: v.number(),
});

export const vBoardReviewDto = v.object({
  id: v.string(),
  book: vBoardBookDto,
  rating: v.number(),
  excerpt: v.pipe(v.string(), v.maxLength(220)),
  readerName: v.nullable(v.string()),
  isMine: v.optional(v.boolean()),
  finishedAt: v.nullable(v.string()),
});

export const vBoardTeamThoughtDto = v.object({
  body: v.string(),
  pageNumber: v.nullable(v.number()),
});

export const vBoardTeamReadingDto = v.object({
  member: vBoardTeamMemberDto,
  book: vBoardBookDto,
  currentPage: v.nullable(v.number()),
  pageCount: v.nullable(v.number()),
  progressPercent: v.nullable(v.number()),
  updatedAt: v.string(),
  thought: v.nullable(vBoardTeamThoughtDto),
});

export const vBoardFeedDto = v.object({
  generatedAt: v.string(),
  month: v.nullable(vBoardMonthSummaryDto),
  monthPresentation: vBoardMonthPresentation,
  picks: v.nullable(vBoardPicksDto),
  quiz: v.nullable(vBoardQuizCardDto),
  recentQuiz: v.nullable(vBoardRecentQuizDto),
  tbrChart: v.nullable(vBoardChartDto),
  finishedChart: v.nullable(vBoardChartDto),
  lines: v.array(vBoardLineItemDto),
  reviews: v.array(vBoardReviewDto),
  team: v.array(vBoardTeamReadingDto),
  nextQuizStartsAt: v.nullable(v.string()),
});

export const vBoardReviewDetailDto = v.object({
  id: v.string(),
  book: vBoardBookDto,
  rating: v.number(),
  excerpt: v.pipe(v.string(), v.maxLength(220)),
  readerName: v.nullable(v.string()),
  isMine: v.optional(v.boolean()),
  finishedAt: v.nullable(v.string()),
  bodyPlainText: v.string(),
});

export const vBoardNextLineDto = v.object({
  item: v.nullable(vBoardLineItemDto),
});

export const vBoardLineSeenDto = v.object({
  recorded: v.boolean(),
});

export const vBoardMonthGoalWeekDto = v.object({
  index: v.number(),
  pages: v.number(),
  target: v.number(),
  met: v.boolean(),
});

export const vBoardMonthGoalDto = v.object({
  pagesPerDay: v.number(),
  weeks: v.array(vBoardMonthGoalWeekDto),
});

export const vBoardMonthFinishedDto = v.object({
  book: vBoardBookDto,
  finishedAt: v.string(),
  rating: v.nullable(v.number()),
});

export const vBoardMonthBookPagesDto = v.object({
  book: vBoardBookDto,
  pages: v.number(),
  pagesInMonth: v.optional(v.number()),
  finished: v.optional(v.boolean()),
  rating: v.nullish(v.number()),
});

export const vLineBookDto = v.object({
  id: v.pipe(v.string(), v.uuid()),
  title: v.string(),
  authors: v.array(v.string()),
  coverImageUrl: v.nullable(v.string()),
});

export const vBoardKeptLineDto = v.object({
  body: v.string(),
  pageNumber: v.nullable(v.number()),
  savedAt: v.string(),
  book: vLineBookDto,
});

export const vBoardBusiestDayDto = v.object({
  date: v.string(),
  pages: v.number(),
});

export const vBoardMonthRecapDto = v.object({
  month: v.string(),
  pagesRead: v.number(),
  booksFinished: v.number(),
  daysWithReading: v.number(),
  quotesSaved: v.number(),
  goal: v.nullable(vBoardMonthGoalDto),
  finished: v.array(vBoardMonthFinishedDto),
  bookPages: v.optional(v.array(vBoardMonthBookPagesDto)),
  keptLine: v.nullable(vBoardKeptLineDto),
  busiestDay: v.nullable(vBoardBusiestDayDto),
  dailyPages: v.array(vBoardBusiestDayDto),
  days: v.optional(v.array(vBoardBusiestDayDto)),
});

export const vBoardQuizOptionDto = v.object({
  id: v.string(),
  book: vBoardBookDto,
});

export const vBoardQuizQuestionDto = v.object({
  id: v.string(),
  prompt: v.string(),
  options: v.array(vBoardQuizOptionDto),
});

export const vBoardQuizAnswerDto = v.object({
  questionId: v.string(),
  optionId: v.string(),
});

export const vBoardQuizDto = v.object({
  id: v.string(),
  title: v.string(),
  endsAt: v.string(),
  host: vBoardTeamMemberDto,
  questions: v.array(vBoardQuizQuestionDto),
  viewerAnswers: v.nullable(v.array(vBoardQuizAnswerDto)),
});

export const vSubmitBoardQuizAnswersRequestDto = v.object({
  answers: v.pipe(v.array(vBoardQuizAnswerDto), v.minLength(1), v.maxLength(4)),
});

export const vBoardQuizResultQuestionDto = v.object({
  id: v.string(),
  prompt: v.string(),
  options: v.array(vBoardQuizResultOptionDto),
});

export const vBoardQuizResultsDto = v.object({
  quizId: v.string(),
  answerCount: v.number(),
  resultsAvailable: v.boolean(),
  questions: v.array(vBoardQuizResultQuestionDto),
});

export const vAccountPresentationRequestDto = v.object({
  providerAvatarUrl: v.nullable(v.pipe(v.string(), v.maxLength(2048))),
  timeZone: v.pipe(v.string(), v.maxLength(100)),
});

export const vAccountPresentationDto = v.object({
  avatarUrl: v.nullable(v.string()),
  timeZone: v.string(),
});

export const vBookLinesDto = v.object({
  book: vLineBookDto,
  items: v.array(vPublicLineDto),
  nextCursor: v.nullable(v.string()),
});

export const vQuoteThoughtDto = v.object({
  textLanguage: v.optional(vTextLanguageDto),
  id: v.pipe(v.string(), v.uuid()),
  annotationId: v.pipe(v.string(), v.uuid()),
  body: v.pipe(v.string(), v.minLength(1), v.maxLength(20000)),
  visibility: v.picklist(['private', 'public']),
  moderationStatus: v.picklist(['not_required', 'pending', 'approved', 'rejected']),
  likeCount: v.pipe(v.number(), v.integer(), v.minValue(0)),
  containsSpoilers: v.boolean(),
  publishedAt: v.nullable(v.pipe(v.string(), v.isoTimestamp())),
  version: v.pipe(v.number(), v.integer(), v.minValue(1)),
  createdAt: v.pipe(v.string(), v.isoTimestamp()),
  updatedAt: v.pipe(v.string(), v.isoTimestamp()),
});

export const vLineDetailDto = v.object({
  id: v.pipe(v.string(), v.uuid()),
  variantId: v.pipe(v.string(), v.uuid()),
  body: v.string(),
  language: v.string(),
  readerCount: v.pipe(v.number(), v.integer(), v.minValue(1)),
  likeCount: v.pipe(v.number(), v.integer(), v.minValue(0)),
  viewerHasLiked: v.boolean(),
  viewerQuoteId: v.nullable(v.pipe(v.string(), v.uuid())),
  pageNumber: v.nullable(v.pipe(v.number(), v.integer())),
  approximatePage: v.boolean(),
  currentPage: v.nullable(v.pipe(v.number(), v.integer())),
  beyondYourPosition: v.boolean(),
  thoughtCount: v.pipe(v.number(), v.integer(), v.minValue(0)),
  thoughts: v.array(vPublicThoughtDto),
  book: vLineBookDto,
  viewerThought: v.nullable(vQuoteThoughtDto),
  thoughtsCursor: v.nullable(v.string()),
});

export const vLineThoughtsDto = v.object({
  items: v.array(vPublicThoughtDto),
  nextCursor: v.nullable(v.string()),
});

export const vUpdateQuoteThoughtRequestDto = v.object({
  textLanguage: v.optional(vTextLanguageDto),
  body: v.pipe(v.string(), v.minLength(1), v.maxLength(20000)),
  visibility: v.optional(v.picklist(['private', 'public']), 'private'),
  containsSpoilers: v.optional(v.boolean(), false),
  expectedVersion: v.pipe(v.number(), v.integer(), v.minValue(0)),
});

export const vSaveLineRequestDto = v.object({
  bookId: v.pipe(v.string(), v.uuid()),
  thought: v.optional(vUpdateQuoteThoughtRequestDto),
});

export const vSaveLineResponseDto = v.object({
  quoteId: v.pipe(v.string(), v.uuid()),
});

export const vThoughtLikeDto = v.object({
  likeCount: v.pipe(v.number(), v.integer(), v.minValue(0)),
  viewerHasLiked: v.boolean(),
});

export const vLibraryRowThoughtDto = v.object({
  id: v.pipe(v.string(), v.uuid()),
  body: v.string(),
  readerName: v.nullable(v.string()),
  likeCount: v.pipe(v.number(), v.integer(), v.minValue(0)),
});

export const vLibraryQuoteRowDto = v.object({
  bookId: v.pipe(v.string(), v.uuid()),
  lineId: v.pipe(v.string(), v.uuid()),
  body: v.string(),
  language: v.string(),
  readerCount: v.pipe(v.number(), v.integer(), v.minValue(3)),
  likeCount: v.pipe(v.number(), v.integer(), v.minValue(0)),
  topThought: v.nullable(vLibraryRowThoughtDto),
});

export const vLibraryQuoteRowStateDto = v.object({
  evaluatedOn: v.pipe(v.string(), v.isoDate()),
  row: v.nullable(vLibraryQuoteRowDto),
});

export const vLibraryQuoteImpressionRequestDto = v.object({
  bookId: v.pipe(v.string(), v.uuid()),
  lineId: v.pipe(v.string(), v.uuid()),
  shownOn: v.pipe(v.string(), v.isoDate()),
  language: v.optional(v.string()),
  timeZone: v.optional(v.string()),
});

export const vLibraryQuoteImpressionDto = v.object({
  recorded: v.boolean(),
});

export const vReadingGoalTargetChangeDto = v.object({
  effectiveOn: v.pipe(v.string(), v.isoDate()),
  target: v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(1000000)),
});

export const vPersonalReadingGoalDto = v.object({
  completedAt: v.nullable(v.pipe(v.string(), v.isoTimestamp())),
  current: v.pipe(v.number(), v.integer(), v.minValue(0)),
  target: v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(1000000)),
  type: v.picklist(['books_completed', 'pages_per_day']),
  year: v.pipe(v.number(), v.integer(), v.minValue(1900), v.maxValue(9999)),
  startDate: v.optional(v.pipe(v.string(), v.isoDate())),
  timeZone: v.optional(v.string()),
  targetHistory: v.optional(v.array(vReadingGoalTargetChangeDto)),
});

export const vReadingPageEventDto = v.object({
  authors: v.array(v.string()),
  bookId: v.pipe(v.string(), v.uuid()),
  coverImageUrl: v.nullable(v.pipe(v.string(), v.url())),
  title: v.string(),
  userBookId: v.pipe(v.string(), v.uuid()),
  id: v.pipe(v.string(), v.uuid()),
  clientEventId: v.nullable(v.pipe(v.string(), v.uuid())),
  occurredAt: v.pipe(v.string(), v.isoTimestamp()),
  fromPage: v.pipe(v.number(), v.integer(), v.minValue(0)),
  toPage: v.pipe(v.number(), v.integer(), v.minValue(0)),
  pagesAdded: v.pipe(v.number(), v.integer(), v.minValue(1)),
});

export const vPersonalReadingGoalContributionDto = v.object({
  authors: v.array(v.string()),
  bookId: v.pipe(v.string(), v.uuid()),
  coverImageUrl: v.nullable(v.pipe(v.string(), v.url())),
  title: v.string(),
  userBookId: v.pipe(v.string(), v.uuid()),
  completionId: v.optional(v.string()),
  completedOn: v.string(),
});

export const vUndatedReadingActivityBookDto = v.object({
  authors: v.array(v.string()),
  bookId: v.pipe(v.string(), v.uuid()),
  coverImageUrl: v.nullable(v.pipe(v.string(), v.url())),
  title: v.string(),
  userBookId: v.pipe(v.string(), v.uuid()),
  completedOn: v.nullable(v.unknown()),
});

export const vReadingActivityHistoryDto = v.object({
  year: v.pipe(v.number(), v.integer(), v.minValue(1900), v.maxValue(9999)),
  timeZone: v.string(),
  pageEvents: v.array(vReadingPageEventDto),
  completedBooks: v.array(vPersonalReadingGoalContributionDto),
  undatedCompletedCount: v.pipe(v.number(), v.integer(), v.minValue(0)),
  undatedCompletedBooks: v.array(vUndatedReadingActivityBookDto),
});

export const vPersonalReadingGoalStateDto = v.object({
  evaluatedAt: v.pipe(v.string(), v.isoTimestamp()),
  goal: v.nullable(vPersonalReadingGoalDto),
  year: v.pipe(v.number(), v.integer(), v.minValue(1900), v.maxValue(9999)),
  history: v.optional(vReadingActivityHistoryDto),
});

export const vSavePersonalReadingGoalRequestDto = v.object({
  target: v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(1000000)),
  type: v.optional(v.picklist(['books_completed', 'pages_per_day']), 'books_completed'),
  timeZone: v.optional(v.string(), 'UTC'),
});

export const vRemovePersonalReadingGoalResponseDto = v.object({
  removed: v.boolean(),
  year: v.pipe(v.number(), v.integer(), v.minValue(1900), v.maxValue(9999)),
});

export const vPersonalReadingGoalDetailDto = v.object({
  completedAt: v.nullable(v.pipe(v.string(), v.isoTimestamp())),
  current: v.pipe(v.number(), v.integer(), v.minValue(0)),
  target: v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(1000000)),
  type: v.picklist(['books_completed', 'pages_per_day']),
  year: v.pipe(v.number(), v.integer(), v.minValue(1900), v.maxValue(9999)),
  startDate: v.optional(v.pipe(v.string(), v.isoDate())),
  timeZone: v.optional(v.string()),
  targetHistory: v.optional(v.array(vReadingGoalTargetChangeDto)),
  contributingBooks: v.array(vPersonalReadingGoalContributionDto),
});

export const vPersonalReadingGoalDetailStateDto = v.object({
  evaluatedAt: v.pipe(v.string(), v.isoTimestamp()),
  goal: v.nullable(vPersonalReadingGoalDetailDto),
  year: v.pipe(v.number(), v.integer(), v.minValue(1900), v.maxValue(9999)),
  history: v.optional(vReadingActivityHistoryDto),
});

export const vCatalogueMetadataDto = v.object({
  title: v.string(),
  subtitle: v.nullish(v.string()),
  authors: v.array(v.string()),
  authorUnknown: v.boolean(),
  language: v.pipe(v.string(), v.length(2)),
  isbn: v.nullish(v.string()),
  publisher: v.nullish(v.string()),
  publishedYear: v.nullish(v.number()),
  pageCount: v.nullish(v.number()),
  binding: v.optional(v.picklist(['paperback', 'hardcover', 'ebook', 'other'])),
  description: v.nullish(v.string()),
});

export const vCatalogueSubmissionDto = v.object({
  id: v.pipe(v.string(), v.uuid()),
  bookId: v.pipe(v.string(), v.uuid()),
  status: v.picklist([
    'pending',
    'changes_requested',
    'declined',
    'withdrawn',
    'published',
    'matched',
  ]),
  version: v.number(),
  metadata: vCatalogueMetadataDto,
  moderatorMessage: v.nullable(v.string()),
  matchedBookId: v.nullable(v.pipe(v.string(), v.uuid())),
  publishedBookId: v.nullable(v.pipe(v.string(), v.uuid())),
  createdAt: v.pipe(v.string(), v.isoTimestamp()),
  updatedAt: v.pipe(v.string(), v.isoTimestamp()),
});

export const vCatalogueSubmissionsDto = v.object({
  items: v.array(vCatalogueSubmissionDto),
});

export const vCatalogueSubmitDto = v.object({
  clientRequestId: v.pipe(v.string(), v.uuid()),
  bookId: v.pipe(v.string(), v.uuid()),
  consent: v.literal(true),
  metadata: vCatalogueMetadataDto,
});

export const vCatalogueResubmitDto = v.object({
  clientRequestId: v.pipe(v.string(), v.uuid()),
  expectedVersion: v.pipe(v.number(), v.minValue(1)),
  consent: v.literal(true),
  metadata: vCatalogueMetadataDto,
});

export const vCatalogueRetryDto = v.object({
  clientRequestId: v.pipe(v.string(), v.uuid()),
  expectedVersion: v.pipe(v.number(), v.minValue(1)),
});

export const vCatalogueReportIssueDto = v.object({
  id: v.pipe(v.string(), v.uuid()),
  target: v.picklist(['cover', 'description', 'book']),
  reasons: v.array(v.string()),
  details: v.string(),
  status: v.picklist(['pending', 'dismissed', 'confirmed', 'replaced', 'resolved']),
  versionKey: v.nullable(v.string()),
  contentVersion: v.nullable(v.number()),
  state: v.picklist(['visible', 'held', 'suppressed']),
  safetyHold: v.boolean(),
  moderatorMessage: v.nullable(v.string()),
  updatedAt: v.pipe(v.string(), v.isoTimestamp()),
});

export const vCatalogueReportDto = v.object({
  bookTitle: v.optional(v.string()),
  id: v.pipe(v.string(), v.uuid()),
  bookId: v.nullable(v.pipe(v.string(), v.uuid())),
  reason: v.picklist([
    'metadata',
    'duplicate',
    'wrong_edition',
    'inappropriate',
    'cover',
    'rights',
  ]),
  issues: v.array(vCatalogueReportIssueDto),
  details: v.string(),
  evidence: v.optional(v.string()),
  targetBookId: v.nullable(v.pipe(v.string(), v.uuid())),
  status: v.picklist(['pending', 'resolved', 'dismissed']),
  version: v.number(),
  moderatorMessage: v.nullable(v.string()),
  createdAt: v.pipe(v.string(), v.isoTimestamp()),
  updatedAt: v.pipe(v.string(), v.isoTimestamp()),
});

export const vCatalogueReportsDto = v.object({
  items: v.array(vCatalogueReportDto),
});

export const vCatalogueReportIssueInputDto = v.object({
  target: v.picklist(['cover', 'description', 'book']),
  reasons: v.pipe(v.array(v.string()), v.minLength(1), v.maxLength(6)),
  details: v.optional(v.pipe(v.string(), v.maxLength(2000))),
});

export const vCatalogueReportInputDto = v.object({
  clientRequestId: v.pipe(v.string(), v.uuid()),
  bookId: v.optional(v.pipe(v.string(), v.uuid())),
  catalogueContentToken: v.optional(v.string()),
  reason: v.optional(
    v.picklist(['metadata', 'duplicate', 'wrong_edition', 'inappropriate', 'cover', 'rights']),
  ),
  issues: v.optional(
    v.pipe(v.array(vCatalogueReportIssueInputDto), v.minLength(1), v.maxLength(3)),
  ),
  details: v.optional(v.pipe(v.string(), v.maxLength(2000))),
  evidence: v.optional(v.pipe(v.string(), v.minLength(20), v.maxLength(2000))),
  targetBookId: v.optional(v.pipe(v.string(), v.uuid())),
});

export const vBookAnnotationKind = v.picklist(['note', 'quote']);

export const vNoteHtmlBlockDto = v.object({
  id: v.pipe(v.string(), v.minLength(1), v.maxLength(64)),
  type: v.picklist(['html']),
  html: v.pipe(v.string(), v.maxLength(200000)),
});

export const vNoteQuoteBlockDto = v.object({
  id: v.pipe(v.string(), v.minLength(1), v.maxLength(64)),
  type: v.picklist(['quote']),
  quoteId: v.pipe(v.string(), v.uuid()),
});

export const vNoteDocumentDto = v.object({
  schemaVersion: v.picklist([1]),
  blocks: v.pipe(v.array(v.unknown()), v.minLength(1), v.maxLength(200)),
});

export const vBookAnnotationDto = v.object({
  textLanguage: v.optional(vTextLanguageDto),
  document: v.optional(vNoteDocumentDto),
  title: v.nullish(v.pipe(v.string(), v.maxLength(200))),
  wholeBook: v.optional(v.boolean()),
  id: v.pipe(v.string(), v.uuid()),
  relationId: v.pipe(v.string(), v.uuid()),
  kind: v.picklist(['note', 'quote']),
  body: v.pipe(v.string(), v.minLength(0), v.maxLength(20000)),
  pageNumber: v.nullable(v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(10000000))),
  pageSource: v.optional(v.picklist(['confirmed', 'inferred'])),
  createdAt: v.pipe(v.string(), v.isoTimestamp()),
  updatedAt: v.pipe(v.string(), v.isoTimestamp()),
  version: v.pipe(v.number(), v.integer(), v.minValue(1)),
});

export const vBookAnnotationListResponseDto = v.object({
  items: v.array(vBookAnnotationDto),
  nextCursor: v.nullable(v.pipe(v.string(), v.maxLength(256))),
});

export const vCreateBookAnnotationRequestDto = v.object({
  textLanguage: v.optional(vTextLanguageDto),
  clientNoteId: v.optional(v.pipe(v.string(), v.uuid())),
  document: v.optional(vNoteDocumentDto),
  captureId: v.optional(v.pipe(v.string(), v.uuid())),
  thought: v.nullish(v.pipe(v.string(), v.minLength(1), v.maxLength(20000))),
  thoughtVisibility: v.optional(v.picklist(['private', 'public']), 'private'),
  thoughtContainsSpoilers: v.optional(v.boolean(), false),
  thoughtTextLanguage: v.optional(vTextLanguageDto),
  title: v.nullish(v.pipe(v.string(), v.maxLength(200))),
  wholeBook: v.optional(v.boolean()),
  kind: v.picklist(['note', 'quote']),
  body: v.pipe(v.string(), v.minLength(0), v.maxLength(20000)),
  pageNumber: v.nullish(v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(10000000))),
  pageSource: v.optional(v.picklist(['confirmed', 'inferred']), 'inferred'),
});

export const vUpdateBookAnnotationRequestDto = v.object({
  textLanguage: v.optional(vTextLanguageDto),
  document: v.optional(vNoteDocumentDto),
  title: v.nullish(v.pipe(v.string(), v.maxLength(200))),
  wholeBook: v.optional(v.boolean()),
  body: v.pipe(v.string(), v.minLength(0), v.maxLength(20000)),
  pageNumber: v.nullable(v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(10000000))),
  pageSource: v.optional(v.picklist(['confirmed', 'inferred'])),
  expectedVersion: v.pipe(v.number(), v.integer(), v.minValue(1)),
});

export const vRemoveBookAnnotationResponseDto = v.object({
  removed: v.literal(true),
});

export const vMyNoteDto = v.object({
  id: v.pipe(v.string(), v.uuid()),
  relationId: v.pipe(v.string(), v.uuid()),
  body: v.pipe(v.string(), v.minLength(0), v.maxLength(20000)),
  title: v.nullish(v.pipe(v.string(), v.maxLength(200))),
  wholeBook: v.optional(v.boolean()),
  document: v.optional(vNoteDocumentDto),
  pageNumber: v.nullable(v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(10000000))),
  createdAt: v.pipe(v.string(), v.isoTimestamp()),
  updatedAt: v.pipe(v.string(), v.isoTimestamp()),
  version: v.pipe(v.number(), v.integer(), v.minValue(1)),
  book: vLibraryBookDto,
});

export const vMyNoteListResponseDto = v.object({
  items: v.array(vMyNoteDto),
  nextCursor: v.nullable(v.pipe(v.string(), v.maxLength(256))),
  total: v.pipe(v.number(), v.integer(), v.minValue(0)),
});

export const vMyQuoteDto = v.object({
  textLanguage: v.optional(vTextLanguageDto),
  id: v.pipe(v.string(), v.uuid()),
  relationId: v.pipe(v.string(), v.uuid()),
  variantId: v.pipe(v.string(), v.uuid()),
  passageId: v.pipe(v.string(), v.uuid()),
  body: v.pipe(v.string(), v.minLength(1), v.maxLength(20000)),
  pageNumber: v.nullable(v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(10000000))),
  pageSource: v.optional(v.picklist(['confirmed', 'inferred'])),
  positionFraction: v.nullish(v.pipe(v.number(), v.minValue(0), v.maxValue(1))),
  language: v.string(),
  visibility: v.picklist(['private', 'public']),
  moderationStatus: v.picklist(['not_required', 'pending', 'approved', 'rejected']),
  readerCount: v.pipe(v.number(), v.integer(), v.minValue(0)),
  likeCount: v.pipe(v.number(), v.integer(), v.minValue(0)),
  viewerHasLiked: v.boolean(),
  createdAt: v.pipe(v.string(), v.isoTimestamp()),
  updatedAt: v.pipe(v.string(), v.isoTimestamp()),
  version: v.pipe(v.number(), v.integer(), v.minValue(1)),
  book: vLibraryBookDto,
});

export const vMyQuoteListResponseDto = v.object({
  items: v.array(vMyQuoteDto),
  nextCursor: v.nullable(v.pipe(v.string(), v.maxLength(256))),
  total: v.pipe(v.number(), v.integer(), v.minValue(0)),
});

export const vUpdateQuoteVisibilityRequestDto = v.object({
  visibility: v.picklist(['private', 'public']),
  expectedVersion: v.pipe(v.number(), v.integer(), v.minValue(1)),
});

export const vQuoteLikeResponseDto = v.object({
  likeCount: v.pipe(v.number(), v.integer(), v.minValue(0)),
  viewerHasLiked: v.boolean(),
});

export const vNoteLinkedQuoteDto = v.object({
  id: v.pipe(v.string(), v.uuid()),
  body: v.string(),
  pageNumber: v.nullable(v.pipe(v.number(), v.integer())),
  version: v.pipe(v.number(), v.integer(), v.minValue(1)),
});

export const vJournalReviewDto = v.object({
  textLanguage: v.optional(vTextLanguageDto),
  containsSpoilers: v.boolean(),
  moderationMessage: v.nullable(v.pipe(v.string(), v.minLength(1), v.maxLength(1000))),
  moderationStatus: v.picklist(['not_required', 'pending', 'approved', 'rejected']),
  publishedAt: v.nullable(v.pipe(v.string(), v.isoTimestamp())),
  visibility: v.picklist(['private', 'public']),
  source: v.picklist(['living_library', 'goodreads']),
  rating: v.nullable(v.pipe(v.number(), v.minValue(0), v.maxValue(5))),
});

export const vJournalEntryDto = v.object({
  textLanguage: v.optional(vTextLanguageDto),
  document: v.optional(vNoteDocumentDto),
  title: v.nullish(v.pipe(v.string(), v.maxLength(200))),
  wholeBook: v.optional(v.boolean()),
  id: v.pipe(v.string(), v.uuid()),
  relationId: v.pipe(v.string(), v.uuid()),
  body: v.pipe(v.string(), v.minLength(0), v.maxLength(100000)),
  pageNumber: v.nullable(v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(10000000))),
  pageSource: v.optional(v.picklist(['confirmed', 'inferred'])),
  createdAt: v.pipe(v.string(), v.isoTimestamp()),
  updatedAt: v.pipe(v.string(), v.isoTimestamp()),
  version: v.pipe(v.number(), v.integer(), v.minValue(1)),
  kind: v.picklist(['quote', 'note', 'review']),
  linkedQuotes: v.optional(v.array(vNoteLinkedQuoteDto)),
  wordCount: v.pipe(v.number(), v.integer(), v.minValue(0)),
  book: vLibraryBookDto,
  quote: v.nullable(vMyQuoteDto),
  thought: v.nullable(vQuoteThoughtDto),
  review: v.nullable(vJournalReviewDto),
});

export const vJournalListResponseDto = v.object({
  items: v.array(vJournalEntryDto),
  nextCursor: v.nullable(v.string()),
  total: v.pipe(v.number(), v.integer(), v.minValue(0)),
});

export const vRemoveQuoteThoughtResponseDto = v.object({
  removed: v.literal(true),
});

export const vPublicBookReviewDto = v.object({
  textLanguage: v.optional(vTextLanguageDto),
  id: v.pipe(v.string(), v.uuid()),
  body: v.pipe(v.string(), v.maxLength(100000)),
  containsSpoilers: v.boolean(),
  reviewerName: v.pipe(v.string(), v.maxLength(120)),
  rating: v.nullable(v.pipe(v.number(), v.minValue(0), v.maxValue(5))),
  publishedAt: v.pipe(v.string(), v.isoTimestamp()),
});

export const vBookCommunityFeedbackDto = v.object({
  externalRating: v.nullable(vExternalRatingDto),
  averageRating: v.nullable(v.pipe(v.number(), v.minValue(0), v.maxValue(5))),
  ratingCount: v.pipe(v.number(), v.integer(), v.minValue(0)),
  reviewCount: v.pipe(v.number(), v.integer(), v.minValue(0)),
  reviews: v.pipe(v.array(vPublicBookReviewDto), v.maxLength(20)),
});

export const vUserBookRatingDto = v.object({
  value: v.pipe(v.number(), v.minValue(0), v.maxValue(5)),
  source: v.picklist(['living_library', 'goodreads']),
  updatedAt: v.pipe(v.string(), v.isoTimestamp()),
  version: v.pipe(v.number(), v.integer(), v.minValue(1)),
});

export const vUserBookReviewDto = v.object({
  textLanguage: v.optional(vTextLanguageDto),
  body: v.pipe(v.string(), v.maxLength(100000)),
  containsSpoilers: v.boolean(),
  moderationMessage: v.nullable(v.pipe(v.string(), v.minLength(1), v.maxLength(1000))),
  moderationStatus: v.picklist(['not_required', 'pending', 'approved', 'rejected']),
  publishedAt: v.nullable(v.pipe(v.string(), v.isoTimestamp())),
  visibility: v.picklist(['private', 'public']),
  source: v.picklist(['living_library', 'goodreads']),
  updatedAt: v.pipe(v.string(), v.isoTimestamp()),
  version: v.pipe(v.number(), v.integer(), v.minValue(1)),
});

export const vUserBookFeedbackDto = v.object({
  rating: v.nullable(vUserBookRatingDto),
  review: v.nullable(vUserBookReviewDto),
});

export const vSetRatingRequestDto = v.object({
  rating: v.pipe(v.number(), v.minValue(0), v.maxValue(5)),
});

export const vRemoveFeedbackResponseDto = v.object({
  removed: v.literal(true),
});

export const vSetReviewRequestDto = v.object({
  textLanguage: v.optional(vTextLanguageDto),
  body: v.pipe(v.string(), v.minLength(1), v.maxLength(100000)),
  containsSpoilers: v.optional(v.boolean(), false),
  visibility: v.picklist(['private', 'public']),
});

export const vCabinetLayoutPlacementDto = v.object({
  id: v.pipe(v.string(), v.minLength(1), v.maxLength(160)),
  inventoryItemId: v.pipe(v.string(), v.minLength(1), v.maxLength(200)),
  presentationId: v.pipe(v.string(), v.minLength(1), v.maxLength(120)),
  slotId: v.pipe(v.string(), v.minLength(1), v.maxLength(120)),
});

export const vCabinetLayoutZoneStateDto = v.object({
  placements: v.pipe(v.array(vCabinetLayoutPlacementDto), v.maxLength(8)),
  recipeId: v.pipe(v.string(), v.minLength(1), v.maxLength(120)),
  variantId: v.pipe(v.string(), v.minLength(1), v.maxLength(120)),
  zoneId: v.pipe(v.string(), v.minLength(1), v.maxLength(120)),
});

export const vCabinetLayoutDocumentDto = v.object({
  authoredDefinitionVersion: v.pipe(v.number(), v.integer(), v.minValue(1)),
  definitionId: v.pipe(v.string(), v.minLength(1), v.maxLength(128)),
  id: v.pipe(v.string(), v.minLength(1), v.maxLength(256)),
  revision: v.pipe(v.number(), v.integer(), v.minValue(0)),
  schemaVersion: v.picklist(['cabinet-layout-document-v1']),
  updatedAt: v.nullable(v.pipe(v.string(), v.isoTimestamp())),
  zones: v.pipe(v.array(vCabinetLayoutZoneStateDto), v.maxLength(16)),
});

export const vSaveCabinetLayoutRequestDto = v.object({
  document: vCabinetLayoutDocumentDto,
  expectedRevision: v.pipe(v.number(), v.integer(), v.minValue(0)),
});

export const vLibraryLayoutBookDto = v.object({
  id: v.pipe(v.string(), v.maxLength(160)),
  row: v.pipe(v.number(), v.integer(), v.minValue(0), v.maxValue(3)),
  bayId: v.pipe(v.number(), v.integer(), v.minValue(-4), v.maxValue(4)),
  x: v.pipe(v.number(), v.minValue(-1300), v.maxValue(1300)),
  kind: v.picklist(['book']),
  bookId: v.pipe(v.string(), v.maxLength(160)),
  display: v.picklist(['cover', 'spine']),
  width: v.pipe(v.number(), v.minValue(1), v.maxValue(226)),
  height: v.pipe(v.number(), v.minValue(5), v.maxValue(340)),
});

export const vLibraryLayoutCollectibleDto = v.object({
  id: v.pipe(v.string(), v.maxLength(160)),
  row: v.pipe(v.number(), v.integer(), v.minValue(0), v.maxValue(3)),
  bayId: v.pipe(v.number(), v.integer(), v.minValue(-4), v.maxValue(4)),
  x: v.pipe(v.number(), v.minValue(-1300), v.maxValue(1300)),
  kind: v.picklist(['collectible']),
  collectibleId: v.picklist(['lamp-reading', 'owl', 'owl-white', 'sphere']),
  enabled: v.optional(v.boolean()),
});

export const vLibraryLayoutPlantDto = v.object({
  id: v.pipe(v.string(), v.maxLength(160)),
  row: v.pipe(v.number(), v.integer(), v.minValue(0), v.maxValue(3)),
  bayId: v.pipe(v.number(), v.integer(), v.minValue(-4), v.maxValue(4)),
  x: v.pipe(v.number(), v.minValue(-1300), v.maxValue(1300)),
  kind: v.picklist(['plant']),
  plantId: v.picklist(['plant-heartleaf', 'plant-string-of-hearts', 'plant-fern']),
  potId: v.picklist(['pot-ivory', 'pot-sage']),
  length: v.picklist([1, 2, 3]),
});

export const vLibraryLayoutDocumentDto = v.object({
  schemaVersion: v.picklist(['modular-library-layout-v1']),
  sideCount: v.picklist([4]),
  removedDividerIds: v.pipe(v.array(v.string()), v.maxLength(24)),
  badgeIds: v.optional(v.pipe(v.array(v.string()), v.maxLength(5))),
  items: v.pipe(v.array(v.unknown()), v.maxLength(256)),
  revision: v.pipe(v.number(), v.integer(), v.minValue(0)),
  updatedAt: v.nullable(v.pipe(v.string(), v.isoTimestamp())),
});

export const vLibraryInventoryGrantDto = v.object({
  collectibleId: v.string(),
  kind: v.picklist(['object', 'plant', 'pot', 'badge']),
  quantity: v.pipe(v.number(), v.integer(), v.minValue(0)),
  source: v.picklist(['starter', 'achievement', 'testing']),
  achievementId: v.nullable(v.string()),
  grantedAt: v.pipe(v.string(), v.isoTimestamp()),
});

export const vLibraryInventoryResponseDto = v.object({
  items: v.array(vLibraryInventoryGrantDto),
});

export const vLibraryLayoutDraftDto = v.object({
  schemaVersion: v.picklist(['modular-library-layout-v1']),
  sideCount: v.picklist([4]),
  removedDividerIds: v.pipe(v.array(v.string()), v.maxLength(24)),
  badgeIds: v.optional(v.pipe(v.array(v.string()), v.maxLength(5))),
  items: v.pipe(v.array(v.unknown()), v.maxLength(256)),
});

export const vSaveLibraryLayoutRequestDto = v.object({
  expectedRevision: v.pipe(v.number(), v.integer(), v.minValue(0), v.maxValue(2147483646)),
  document: vLibraryLayoutDraftDto,
});

export const vLibraryResourceReleaseDto = v.object({
  releaseId: v.pipe(v.string(), v.regex(/^sha256-[a-f0-9]{64}$/)),
  releaseSequence: v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(2147483647)),
  manifestUrl: v.pipe(v.string(), v.url()),
  manifestSha256: v.pipe(v.string(), v.regex(/^[a-f0-9]{64}$/)),
});

export const vLibraryResourceCatalogueItemDto = v.object({
  resourceId: v.pipe(v.string(), v.maxLength(160), v.regex(/^[a-z][a-z0-9.-]{0,159}$/)),
  kind: v.picklist(['object', 'plant', 'pot', 'badge', 'theme_pack']),
  owned: v.boolean(),
  release: v.nullable(vLibraryResourceReleaseDto),
  previewUrl: v.nullable(v.pipe(v.string(), v.url())),
});

export const vLibraryResourceCatalogueResponseDto = v.object({
  schemaVersion: v.picklist(['library-resource-catalogue-v1']),
  items: v.array(vLibraryResourceCatalogueItemDto),
});

export const vThemePackEntitlementDto = v.object({
  collectibleType: v.picklist(['theme_pack']),
  grantedAt: v.pipe(v.string(), v.isoTimestamp()),
  grantSourceId: v.pipe(v.string(), v.minLength(1), v.maxLength(200)),
  grantSourceType: v.picklist(['testing', 'achievement']),
  themeId: v.pipe(v.string(), v.minLength(1), v.maxLength(120)),
});

export const vReaderThemeStateDto = v.object({
  activeThemeId: v.pipe(v.string(), v.minLength(1), v.maxLength(120)),
  entitlements: v.array(vThemePackEntitlementDto),
  revision: v.pipe(v.number(), v.integer(), v.minValue(0)),
  schemaVersion: v.picklist(['reader-theme-state-v1']),
  updatedAt: v.nullable(v.pipe(v.string(), v.isoTimestamp())),
});

export const vCompatibleThemePackReleaseDto = v.object({
  releaseId: v.pipe(v.string(), v.regex(/^sha256-[a-f0-9]{64}$/)),
  releaseSequence: v.pipe(v.number(), v.integer(), v.minValue(1)),
  manifestUrl: v.pipe(v.string(), v.url(), v.maxLength(2048)),
  manifestSha256: v.pipe(v.string(), v.regex(/^[a-f0-9]{64}$/)),
});

export const vThemePackCatalogueThumbnailDto = v.object({
  byteLength: v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(524288)),
  height: v.pipe(v.number(), v.integer(), v.minValue(64), v.maxValue(1024)),
  sha256: v.pipe(v.string(), v.regex(/^[a-f0-9]{64}$/)),
  url: v.pipe(v.string(), v.url(), v.maxLength(2048)),
  width: v.pipe(v.number(), v.integer(), v.minValue(64), v.maxValue(1024)),
});

export const vThemePackCataloguePackDto = v.object({
  themeId: v.pipe(v.string(), v.minLength(1), v.maxLength(120)),
  owned: v.boolean(),
  compatibleRelease: v.nullable(vCompatibleThemePackReleaseDto),
  thumbnail: v.nullish(vThemePackCatalogueThumbnailDto),
});

export const vThemePackCatalogueResponseDto = v.object({
  activeThemeId: v.pipe(v.string(), v.minLength(1), v.maxLength(120)),
  packs: v.array(vThemePackCataloguePackDto),
  revision: v.pipe(v.number(), v.integer(), v.minValue(0)),
  schemaVersion: v.picklist(['theme-pack-catalogue-v1', 'theme-pack-catalogue-v2']),
});

export const vSaveThemePreferenceRequestDto = v.object({
  activeThemeId: v.pipe(v.string(), v.minLength(1), v.maxLength(120)),
  expectedRevision: v.pipe(v.number(), v.integer(), v.minValue(0)),
});

export const vGoodreadsUnmatchedBookDto = v.object({
  rowId: v.pipe(v.string(), v.uuid()),
  title: v.string(),
  authors: v.array(v.string()),
  isbn: v.nullable(v.string()),
});

export const vGoodreadsImportCompletedCountsDto = v.object({
  conflicts: v.pipe(v.number(), v.integer(), v.minValue(0)),
  created: v.pipe(v.number(), v.integer(), v.minValue(0)),
  skipped: v.pipe(v.number(), v.integer(), v.minValue(0)),
  unchanged: v.pipe(v.number(), v.integer(), v.minValue(0)),
  updated: v.pipe(v.number(), v.integer(), v.minValue(0)),
});

export const vGoodreadsUnresolvedShelfDto = v.object({
  bookCount: v.pipe(v.number(), v.integer(), v.minValue(1)),
  sourceShelf: v.pipe(v.string(), v.minLength(1), v.maxLength(100)),
});

export const vGoodreadsImportPlanDto = v.object({
  unmatchedBooks: v.optional(v.array(vGoodreadsUnmatchedBookDto)),
  appliedAt: v.nullable(v.pipe(v.string(), v.isoTimestamp())),
  baseLibraryRevision: v.pipe(v.number(), v.integer(), v.minValue(0)),
  booksMatched: v.pipe(v.number(), v.integer(), v.minValue(0)),
  booksToCreate: v.pipe(v.number(), v.integer(), v.minValue(0)),
  booksWithConflicts: v.pipe(v.number(), v.integer(), v.minValue(0)),
  consentPolicyVersion: v.pipe(
    v.string(),
    v.maxLength(64),
    v.regex(/^[A-Za-z0-9][A-Za-z0-9._:-]{0,63}$/),
  ),
  completedCounts: v.nullable(vGoodreadsImportCompletedCountsDto),
  externalAverageBooks: v.pipe(v.number(), v.integer(), v.minValue(0)),
  importId: v.pipe(v.string(), v.uuid()),
  invalidRows: v.pipe(v.number(), v.integer(), v.minValue(0)),
  privateNoteBooks: v.pipe(v.number(), v.integer(), v.minValue(0)),
  ratedBooks: v.pipe(v.number(), v.integer(), v.minValue(0)),
  reviewedBooks: v.pipe(v.number(), v.integer(), v.minValue(0)),
  stagingExpiresAt: v.pipe(v.string(), v.isoTimestamp()),
  status: v.picklist([
    'preparing',
    'ready',
    'applying',
    'completed',
    'failed',
    'cancelled',
    'reverted',
  ]),
  unresolvedShelves: v.array(vGoodreadsUnresolvedShelfDto),
  validRows: v.pipe(v.number(), v.integer(), v.minValue(0)),
});

export const vGoodreadsImportProgressDto = v.object({
  importId: v.pipe(v.string(), v.uuid()),
  status: v.picklist([
    'preparing',
    'ready',
    'applying',
    'completed',
    'failed',
    'cancelled',
    'reverted',
  ]),
  background: v.nullable(v.picklist(['queued', 'running', 'stopped'])),
  books: v.pipe(v.number(), v.integer(), v.minValue(0)),
  appliedRows: v.pipe(v.number(), v.integer(), v.minValue(0)),
  totalRows: v.nullable(v.pipe(v.number(), v.integer(), v.minValue(0))),
  failureCode: v.nullable(v.string()),
  createdAt: v.pipe(v.string(), v.isoTimestamp()),
  preparedAt: v.nullable(v.pipe(v.string(), v.isoTimestamp())),
  appliedAt: v.nullable(v.pipe(v.string(), v.isoTimestamp())),
});

export const vCurrentGoodreadsImportResponseDto = v.object({
  import: v.nullable(vGoodreadsImportProgressDto),
});

export const vCancelGoodreadsImportResponseDto = v.object({
  importId: v.pipe(v.string(), v.uuid()),
  status: v.picklist(['cancelled']),
});

export const vGoodreadsImportResultDto = v.object({
  appliedAt: v.pipe(v.string(), v.isoTimestamp()),
  conflicts: v.pipe(v.number(), v.integer(), v.minValue(0)),
  created: v.pipe(v.number(), v.integer(), v.minValue(0)),
  importId: v.pipe(v.string(), v.uuid()),
  privateNotesNotImported: v.pipe(v.number(), v.integer(), v.minValue(0)),
  ratingsImported: v.pipe(v.number(), v.integer(), v.minValue(0)),
  reviewsImported: v.pipe(v.number(), v.integer(), v.minValue(0)),
  skipped: v.pipe(v.number(), v.integer(), v.minValue(0)),
  status: v.picklist(['completed']),
  unchanged: v.pipe(v.number(), v.integer(), v.minValue(0)),
  updated: v.pipe(v.number(), v.integer(), v.minValue(0)),
});

export const vGoodreadsImportApplyProgressDto = v.object({
  appliedRows: v.pipe(v.number(), v.integer(), v.minValue(0)),
  importId: v.pipe(v.string(), v.uuid()),
  status: v.picklist(['applying']),
  totalRows: v.pipe(v.number(), v.integer(), v.minValue(0)),
  background: v.nullish(v.picklist(['queued', 'running', 'stopped'])),
});

export const vGoodreadsShelfMappingRequestDto = v.object({
  sourceShelf: v.pipe(v.string(), v.minLength(1), v.maxLength(100)),
  status: v.picklist(['to_be_read', 'currently_reading', 'already_read', 'did_not_finish']),
});

export const vApplyGoodreadsImportRequestDto = v.object({
  customBookRowIds: v.optional(v.pipe(v.array(v.string()), v.maxLength(250))),
  consentPolicyVersion: v.pipe(
    v.string(),
    v.maxLength(64),
    v.regex(/^[A-Za-z0-9][A-Za-z0-9._:-]{0,63}$/),
  ),
  ratingsForRecommendations: v.boolean(),
  reviewVisibility: v.picklist(['private', 'public']),
  shelfMappings: v.pipe(v.array(vGoodreadsShelfMappingRequestDto), v.maxLength(100)),
});

export const vUploadMyAvatarBody = v.string();

export const vUploadMyAvatarResponse = vAvatarUpdatedDto;

export const vSetMyAvatarSourceBody = vAvatarSourceDto;

export const vSetMyAvatarSourceResponse = vAvatarUpdatedDto;

export const vReportClientContractViolationBody = vClientContractViolationDto;

export const vReportClientContractViolationResponse = v.void();

export const vGetHealthResponse = vHealthResponseDto;

export const vGetReadinessResponse = vReadinessResponseDto;

export const vDeleteMyAccountBody = vDeleteAccountRequestDto;

/**
 * Account, personal data, uploaded avatar and WorkOS identity removed.
 */
export const vDeleteMyAccountResponse = v.void();

export const vGetAuthenticatedUserResponse = vAuthenticatedUserResponseDto;

export const vGetUsernameAvailabilityQuery = v.object({
  username: v.string(),
});

export const vGetUsernameAvailabilityResponse = vUsernameAvailabilityDto;

export const vUpdateMyProfileBody = vUpdateProfileRequestDto;

export const vUpdateMyProfileResponse = vAuthenticatedUserResponseDto;

export const vGetReadingLanguagesQuery = v.object({
  language: v.optional(v.string()),
});

export const vGetReadingLanguagesResponse = vReadingLanguagesDto;

export const vSetReadingLanguagesBody = vReadingLanguagesDto;

export const vSetReadingLanguagesResponse = vReadingLanguagesDto;

export const vGetContentLanguagesQuery = v.object({
  language: v.optional(v.string()),
});

export const vGetContentLanguagesResponse = vContentLanguagesDto;

export const vSetContentLanguagesBody = vContentLanguagesDto;

export const vSetContentLanguagesResponse = vContentLanguagesDto;

export const vDownloadMyDataQuery = v.object({
  format: v.optional(v.picklist(['backup', 'goodreads', 'notebook'])),
  locale: v.optional(v.picklist(['sk', 'cs', 'en'])),
});

/**
 * Full backup ZIP (CSV, Markdown, JSON), Goodreads CSV with Content-Length, or Markdown-only ZIP
 */
export const vDownloadMyDataResponse = v.string();

export const vGetFindAuthorSuggestionsQuery = v.object({
  languages: v.optional(v.string()),
  query: v.pipe(v.string(), v.maxLength(120)),
});

export const vGetFindAuthorSuggestionsResponse = vFindAuthorSuggestionsDto;

export const vGetAuthorProfileQuery = v.object({
  position: v.optional(v.pipe(v.number(), v.integer(), v.minValue(0), v.maxValue(7))),
  isbn: v.optional(v.pipe(v.string(), v.maxLength(32))),
  name: v.pipe(v.string(), v.maxLength(500)),
});

export const vGetAuthorProfileResponse = vAuthorProfileDto;

export const vCreateCustomBookBody = vCreateCustomBookRequestDto;

export const vCreateCustomBookResponse = vUserBookRelationDto;

export const vGetCatalogueAuthorSuggestionsQuery = v.object({
  query: v.optional(v.pipe(v.string(), v.maxLength(120))),
});

export const vGetCatalogueAuthorSuggestionsResponse = vCatalogueAuthorSuggestionsDto;

export const vGetChamberResponse = vChamberResponseDto;

export const vSearchBooksQuery = v.object({
  authorRef: v.optional(v.pipe(v.string(), v.maxLength(1600))),
  cursor: v.optional(v.string()),
  pageSize: v.optional(v.number()),
  searchMode: v.optional(v.picklist(['standard', 'wider'])),
  searchIn: v.optional(v.picklist(['all', 'title', 'author', 'isbn'])),
  languages: v.optional(v.pipe(v.string(), v.maxLength(47))),
  q: v.optional(v.pipe(v.string(), v.maxLength(120))),
});

export const vSearchBooksResponse = vBookSearchResponseDto;

export const vResolveBookByIsbnBody = vResolveBookByIsbnRequestDto;

export const vResolveBookByIsbnResponse = vLibraryBookDto;

export const vGetBookPath = v.object({
  bookId: v.pipe(v.string(), v.uuid()),
});

export const vGetBookResponse = vLibraryBookDto;

export const vGetBookEditionsPath = v.object({
  bookId: v.pipe(v.string(), v.uuid()),
});

export const vGetBookEditionsQuery = v.object({
  languages: v.optional(v.pipe(v.string(), v.maxLength(47))),
  offset: v.optional(v.pipe(v.number(), v.integer(), v.minValue(0))),
  includeRegional: v.optional(v.boolean()),
});

export const vGetBookEditionsResponse = vBookEditionsResponseDto;

export const vListUserBookRelationsQuery = v.object({
  status: v.optional(vReadingStatus),
  workForBookId: v.optional(v.pipe(v.string(), v.uuid())),
});

export const vListUserBookRelationsResponse = vUserLibraryResponseDto;

export const vUpsertUserBookRelationBody = vUpsertUserBookRequestDto;

export const vUpsertUserBookRelationResponse = vUserBookRelationDto;

export const vGetReadingHistoryPath = v.object({
  relationId: v.pipe(v.string(), v.uuid()),
});

export const vGetReadingHistoryQuery = v.object({
  limit: v.optional(v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(500))),
});

export const vGetReadingHistoryResponse = vReadingHistoryResponseDto;

export const vRemoveUserBookRelationPath = v.object({
  relationId: v.pipe(v.string(), v.uuid()),
});

export const vRemoveUserBookRelationResponse = vRemoveUserBookRelationResponseDto;

export const vUpdateUserBookRelationBody = vUpdateUserBookRequestDto;

export const vUpdateUserBookRelationPath = v.object({
  relationId: v.pipe(v.string(), v.uuid()),
});

export const vUpdateUserBookRelationResponse = vUserBookRelationDto;

export const vUpdateReadingProgressBody = vUpdateReadingProgressRequestDto;

export const vUpdateReadingProgressPath = v.object({
  relationId: v.pipe(v.string(), v.uuid()),
});

export const vUpdateReadingProgressResponse = vUserBookRelationDto;

export const vUpdatePersonalPageCountBody = vUpdatePersonalPageCountRequestDto;

export const vUpdatePersonalPageCountPath = v.object({
  relationId: v.pipe(v.string(), v.uuid()),
});

export const vUpdatePersonalPageCountResponse = vUserBookRelationDto;

export const vGetPublicBookPath = v.object({
  bookId: v.pipe(v.string(), v.uuid()),
});

export const vGetPublicBookResponse = vLibraryBookDto;

export const vGetCommunityStatusResponse = vCommunityStatusDto;

export const vAcceptCommunityTermsBody = vAcceptCommunityTermsRequestDto;

export const vAcceptCommunityTermsResponse = vCommunityStatusDto;

export const vReportCommunityContentBody = vCreateCommunityReportRequestDto;

export const vReportCommunityContentResponse = vCommunityReportReceiptDto;

export const vListBlockedReadersResponse = vBlockedReadersDto;

export const vBlockReaderBody = vBlockReaderRequestDto;

export const vBlockReaderResponse = vBlockReaderResponseDto;

export const vUnblockReaderPath = v.object({
  userId: v.pipe(v.string(), v.uuid()),
});

export const vUnblockReaderResponse = vUnblockReaderResponseDto;

export const vGetMyAchievementCatalogueQuery = v.object({
  libraryItemRewards: v.optional(v.boolean()),
});

export const vGetMyAchievementCatalogueResponse = vReaderAchievementCatalogueStateDto;

export const vSelectMyCatalogueAchievementReadingBody = vSelectAchievementReadingRequestDto;

export const vSelectMyCatalogueAchievementReadingPath = v.object({
  achievementId: v.pipe(v.string(), v.maxLength(80)),
});

export const vSelectMyCatalogueAchievementReadingQuery = v.object({
  libraryItemRewards: v.optional(v.boolean()),
});

export const vSelectMyCatalogueAchievementReadingResponse = vReaderAchievementCatalogueStateDto;

export const vGetMyAchievementsResponse = vReaderAchievementStateDto;

export const vSelectMyAchievementReadingBody = vSelectAchievementReadingRequestDto;

export const vSelectMyAchievementReadingResponse = vReaderAchievementStateDto;

export const vListBoardPicksResponse = v.array(vAdminBoardEditorialDto);

export const vCreateBoardPicksBody = vSaveBoardEditorialRequestDto;

export const vCreateBoardPicksResponse = vAdminBoardEditorialDto;

export const vDeleteBoardPicksPath = v.object({
  id: v.string(),
});

export const vDeleteBoardPicksQuery = v.object({
  version: v.number(),
});

export const vGetBoardPicksPath = v.object({
  id: v.string(),
});

export const vGetBoardPicksResponse = vAdminBoardEditorialDto;

export const vSaveBoardPicksBody = vSaveBoardEditorialRequestDto;

export const vSaveBoardPicksPath = v.object({
  id: v.string(),
});

export const vSaveBoardPicksResponse = vAdminBoardEditorialDto;

export const vPublishBoardPicksBody = vBoardEditorialActionRequestDto;

export const vPublishBoardPicksPath = v.object({
  id: v.string(),
});

export const vPublishBoardPicksResponse = vAdminBoardEditorialDto;

export const vListBoardQuizzesResponse = v.array(vAdminBoardEditorialDto);

export const vCreateBoardQuizBody = vSaveBoardEditorialRequestDto;

export const vCreateBoardQuizResponse = vAdminBoardEditorialDto;

export const vDeleteBoardQuizPath = v.object({
  id: v.string(),
});

export const vDeleteBoardQuizQuery = v.object({
  version: v.number(),
});

export const vGetAdminBoardQuizPath = v.object({
  id: v.string(),
});

export const vGetAdminBoardQuizResponse = vAdminBoardEditorialDto;

export const vSaveBoardQuizBody = vSaveBoardEditorialRequestDto;

export const vSaveBoardQuizPath = v.object({
  id: v.string(),
});

export const vSaveBoardQuizResponse = vAdminBoardEditorialDto;

export const vPublishBoardQuizBody = vBoardEditorialActionRequestDto;

export const vPublishBoardQuizPath = v.object({
  id: v.string(),
});

export const vPublishBoardQuizResponse = vAdminBoardEditorialDto;

export const vSearchBoardCatalogueQuery = v.object({
  language: v.picklist(['sk', 'cs', 'en']),
  query: v.string(),
});

export const vSearchBoardCatalogueResponse = vBookSearchResponseDto;

export const vResolveBoardWorkBody = vResolveBoardWorkRequestDto;

export const vResolveBoardWorkResponse = vAdminBoardWorkDto;

export const vGetBoardWorkPath = v.object({
  id: v.string(),
});

export const vGetBoardWorkResponse = vAdminBoardWorkDto;

export const vListBoardTeamQuery = v.object({
  query: v.optional(v.string()),
});

export const vListBoardTeamResponse = v.array(vAdminBoardTeamDto);

export const vUpdateBoardTeamBody = vUpdateBoardTeamRequestDto;

export const vUpdateBoardTeamPath = v.object({
  id: v.string(),
});

export const vUpdateBoardTeamResponse = vAdminBoardTeamDto;

export const vListBoardModerationQuery = v.object({
  hidden: v.optional(v.string()),
  query: v.optional(v.string()),
  kind: v.optional(v.picklist(['review', 'line', 'team_book'])),
});

export const vListBoardModerationResponse = v.array(vBoardModerationItemDto);

export const vHideBoardItemBody = vUpdateBoardVisibilityRequestDto;

export const vHideBoardItemPath = v.object({
  id: v.string(),
  kind: v.picklist(['review', 'line', 'team_book']),
});

export const vHideBoardItemResponse = vBoardModerationItemDto;

export const vGetBoardQuery = v.object({
  language: v.picklist(['en', 'sk', 'cs']),
});

export const vGetBoardResponse = vBoardFeedDto;

export const vGetBoardReviewPath = v.object({
  reviewId: v.string(),
});

export const vGetBoardReviewQuery = v.object({
  language: v.picklist(['en', 'sk', 'cs']),
});

export const vGetBoardReviewResponse = vBoardReviewDetailDto;

export const vGetBoardChartPath = v.object({
  status: v.picklist(['to_be_read', 'already_read']),
});

export const vGetBoardChartQuery = v.object({
  language: v.picklist(['en', 'sk', 'cs']),
});

export const vGetBoardChartResponse = vBoardChartDto;

export const vGetNextBoardLineQuery = v.object({
  selection: v.optional(v.picklist(['recent', 'popular', 'discovery'])),
  exclude: v.optional(v.pipe(v.string(), v.maxLength(3699))),
  language: v.picklist(['en', 'sk', 'cs']),
});

export const vGetNextBoardLineResponse = vBoardNextLineDto;

export const vGetBoardLinePath = v.object({
  lineId: v.string(),
});

export const vGetBoardLineQuery = v.object({
  language: v.picklist(['en', 'sk', 'cs']),
});

export const vGetBoardLineResponse = vBoardLineItemDto;

export const vMarkBoardLineSeenPath = v.object({
  lineId: v.string(),
});

export const vMarkBoardLineSeenQuery = v.object({
  language: v.picklist(['en', 'sk', 'cs']),
});

export const vMarkBoardLineSeenResponse = vBoardLineSeenDto;

export const vGetBoardMonthPath = v.object({
  month: v.string(),
});

export const vGetBoardMonthQuery = v.object({
  language: v.picklist(['en', 'sk', 'cs']),
});

export const vGetBoardMonthResponse = vBoardMonthRecapDto;

export const vGetBoardQuizPath = v.object({
  quizId: v.string(),
});

export const vGetBoardQuizQuery = v.object({
  language: v.picklist(['en', 'sk', 'cs']),
});

export const vGetBoardQuizResponse = vBoardQuizDto;

export const vSubmitBoardQuizAnswersBody = vSubmitBoardQuizAnswersRequestDto;

export const vSubmitBoardQuizAnswersPath = v.object({
  quizId: v.string(),
});

export const vSubmitBoardQuizAnswersQuery = v.object({
  language: v.picklist(['en', 'sk', 'cs']),
});

export const vSubmitBoardQuizAnswersResponse = vBoardQuizResultsDto;

export const vGetBoardQuizResultsPath = v.object({
  quizId: v.string(),
});

export const vGetBoardQuizResultsQuery = v.object({
  language: v.picklist(['en', 'sk', 'cs']),
});

export const vGetBoardQuizResultsResponse = vBoardQuizResultsDto;

export const vSyncAccountPresentationBody = vAccountPresentationRequestDto;

export const vSyncAccountPresentationResponse = vAccountPresentationDto;

export const vListBookLinesPath = v.object({
  bookId: v.pipe(v.string(), v.uuid()),
});

export const vListBookLinesQuery = v.object({
  preview: v.optional(v.boolean()),
  cursor: v.optional(v.string()),
  sort: v.optional(v.picklist(['saved', 'liked'])),
  language: v.optional(v.string()),
});

export const vListBookLinesResponse = vBookLinesDto;

export const vGetPublicLinePath = v.object({
  lineId: v.pipe(v.string(), v.uuid()),
});

export const vGetPublicLineQuery = v.object({
  language: v.optional(v.string()),
  bookId: v.pipe(v.string(), v.uuid()),
});

export const vGetPublicLineResponse = vLineDetailDto;

export const vListLineThoughtsPath = v.object({
  lineId: v.pipe(v.string(), v.uuid()),
});

export const vListLineThoughtsQuery = v.object({
  cursor: v.optional(v.string()),
  language: v.optional(v.string()),
  bookId: v.pipe(v.string(), v.uuid()),
});

export const vListLineThoughtsResponse = vLineThoughtsDto;

export const vSavePublicLineBody = vSaveLineRequestDto;

export const vSavePublicLinePath = v.object({
  lineId: v.pipe(v.string(), v.uuid()),
});

export const vSavePublicLineResponse = vSaveLineResponseDto;

export const vUnlikePublicThoughtPath = v.object({
  thoughtId: v.pipe(v.string(), v.uuid()),
});

export const vUnlikePublicThoughtResponse = vThoughtLikeDto;

export const vLikePublicThoughtPath = v.object({
  thoughtId: v.pipe(v.string(), v.uuid()),
});

export const vLikePublicThoughtResponse = vThoughtLikeDto;

export const vGetLibraryQuoteRowQuery = v.object({
  timeZone: v.optional(v.string()),
  language: v.optional(v.string()),
  bookId: v.pipe(v.string(), v.uuid()),
});

export const vGetLibraryQuoteRowResponse = vLibraryQuoteRowStateDto;

export const vRecordLibraryQuoteImpressionBody = vLibraryQuoteImpressionRequestDto;

export const vRecordLibraryQuoteImpressionResponse = vLibraryQuoteImpressionDto;

export const vRemoveCurrentPersonalReadingGoalQuery = v.object({
  timeZone: v.optional(v.string()),
});

export const vRemoveCurrentPersonalReadingGoalResponse = vRemovePersonalReadingGoalResponseDto;

export const vGetCurrentPersonalReadingGoalQuery = v.object({
  timeZone: v.optional(v.string()),
});

export const vGetCurrentPersonalReadingGoalResponse = vPersonalReadingGoalStateDto;

export const vSaveCurrentPersonalReadingGoalBody = vSavePersonalReadingGoalRequestDto;

export const vSaveCurrentPersonalReadingGoalResponse = vPersonalReadingGoalStateDto;

export const vGetPersonalReadingGoalPath = v.object({
  year: v.pipe(v.number(), v.integer()),
});

export const vGetPersonalReadingGoalQuery = v.object({
  timeZone: v.optional(v.string()),
});

export const vGetPersonalReadingGoalResponse = vPersonalReadingGoalDetailStateDto;

export const vListCatalogueSubmissionsQuery = v.object({
  bookId: v.optional(v.pipe(v.string(), v.uuid())),
});

export const vListCatalogueSubmissionsResponse = vCatalogueSubmissionsDto;

export const vSubmitCatalogueBookBody = vCatalogueSubmitDto;

export const vSubmitCatalogueBookResponse = vCatalogueSubmissionDto;

export const vGetCatalogueSubmissionPath = v.object({
  id: v.string(),
});

export const vGetCatalogueSubmissionResponse = vCatalogueSubmissionDto;

export const vResubmitCatalogueBookBody = vCatalogueResubmitDto;

export const vResubmitCatalogueBookPath = v.object({
  id: v.string(),
});

export const vResubmitCatalogueBookResponse = vCatalogueSubmissionDto;

export const vWithdrawCatalogueSubmissionBody = vCatalogueRetryDto;

export const vWithdrawCatalogueSubmissionPath = v.object({
  id: v.string(),
});

export const vWithdrawCatalogueSubmissionResponse = vCatalogueSubmissionDto;

export const vAcceptCatalogueSubmissionMatchBody = vCatalogueRetryDto;

export const vAcceptCatalogueSubmissionMatchPath = v.object({
  id: v.string(),
});

export const vAcceptCatalogueSubmissionMatchResponse = vCatalogueSubmissionDto;

export const vListMyCatalogueReportsResponse = vCatalogueReportsDto;

export const vReportCatalogueBookBody = vCatalogueReportInputDto;

export const vReportCatalogueBookResponse = vCatalogueReportDto;

export const vListBookAnnotationsPath = v.object({
  relationId: v.pipe(v.string(), v.uuid()),
});

export const vListBookAnnotationsQuery = v.object({
  cursor: v.optional(v.pipe(v.string(), v.maxLength(256))),
  limit: v.optional(v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(100)), 50),
  kind: v.optional(vBookAnnotationKind),
});

export const vListBookAnnotationsResponse = vBookAnnotationListResponseDto;

export const vCreateBookAnnotationBody = vCreateBookAnnotationRequestDto;

export const vCreateBookAnnotationPath = v.object({
  relationId: v.pipe(v.string(), v.uuid()),
});

export const vCreateBookAnnotationResponse = vBookAnnotationDto;

export const vRemoveBookAnnotationPath = v.object({
  annotationId: v.pipe(v.string(), v.uuid()),
  relationId: v.pipe(v.string(), v.uuid()),
});

export const vRemoveBookAnnotationQuery = v.object({
  expectedVersion: v.pipe(v.number(), v.integer(), v.minValue(1)),
});

export const vRemoveBookAnnotationResponse = vRemoveBookAnnotationResponseDto;

export const vUpdateBookAnnotationBody = vUpdateBookAnnotationRequestDto;

export const vUpdateBookAnnotationPath = v.object({
  annotationId: v.pipe(v.string(), v.uuid()),
  relationId: v.pipe(v.string(), v.uuid()),
});

export const vUpdateBookAnnotationResponse = vBookAnnotationDto;

export const vListMyNotesQuery = v.object({
  sort: v.optional(v.picklist(['newest', 'oldest'])),
  createdAfter: v.optional(
    v.pipe(
      v.string(),
      v.isoTimestamp(),
      v.regex(
        /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,3}))?(Z|[+-]\d{2}:\d{2})$/,
      ),
    ),
  ),
  author: v.optional(v.pipe(v.array(v.pipe(v.string(), v.maxLength(500))), v.maxLength(50))),
  bookId: v.optional(
    v.union([
      v.pipe(v.string(), v.uuid()),
      v.pipe(v.array(v.pipe(v.string(), v.uuid())), v.maxLength(50)),
    ]),
  ),
  query: v.optional(v.pipe(v.string(), v.maxLength(200))),
  cursor: v.optional(v.pipe(v.string(), v.maxLength(256))),
  limit: v.optional(v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(100)), 50),
});

export const vListMyNotesResponse = vMyNoteListResponseDto;

export const vListMyQuotesQuery = v.object({
  sort: v.optional(v.picklist(['newest', 'oldest'])),
  createdAfter: v.optional(
    v.pipe(
      v.string(),
      v.isoTimestamp(),
      v.regex(
        /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,3}))?(Z|[+-]\d{2}:\d{2})$/,
      ),
    ),
  ),
  author: v.optional(v.pipe(v.array(v.pipe(v.string(), v.maxLength(500))), v.maxLength(50))),
  bookId: v.optional(
    v.union([
      v.pipe(v.string(), v.uuid()),
      v.pipe(v.array(v.pipe(v.string(), v.uuid())), v.maxLength(50)),
    ]),
  ),
  query: v.optional(v.pipe(v.string(), v.maxLength(200))),
  cursor: v.optional(v.pipe(v.string(), v.maxLength(256))),
  limit: v.optional(v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(100)), 50),
});

export const vListMyQuotesResponse = vMyQuoteListResponseDto;

export const vUpdateQuoteVisibilityBody = vUpdateQuoteVisibilityRequestDto;

export const vUpdateQuoteVisibilityPath = v.object({
  quoteId: v.pipe(v.string(), v.uuid()),
});

export const vUpdateQuoteVisibilityResponse = vMyQuoteDto;

export const vUnlikeQuotePath = v.object({
  variantId: v.pipe(v.string(), v.uuid()),
});

export const vUnlikeQuoteResponse = vQuoteLikeResponseDto;

export const vLikeQuotePath = v.object({
  variantId: v.pipe(v.string(), v.uuid()),
});

export const vLikeQuoteResponse = vQuoteLikeResponseDto;

export const vUnlikeLinePath = v.object({
  lineId: v.pipe(v.string(), v.uuid()),
});

export const vUnlikeLineResponse = vQuoteLikeResponseDto;

export const vLikeLinePath = v.object({
  lineId: v.pipe(v.string(), v.uuid()),
});

export const vLikeLineResponse = vQuoteLikeResponseDto;

export const vListMyJournalQuery = v.object({
  kind: v.optional(v.picklist(['quote', 'note', 'review'])),
  sort: v.optional(v.picklist(['newest', 'oldest'])),
  createdAfter: v.optional(
    v.pipe(
      v.string(),
      v.isoTimestamp(),
      v.regex(
        /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,3}))?(Z|[+-]\d{2}:\d{2})$/,
      ),
    ),
  ),
  author: v.optional(v.pipe(v.array(v.pipe(v.string(), v.maxLength(500))), v.maxLength(50))),
  bookId: v.optional(
    v.union([
      v.pipe(v.string(), v.uuid()),
      v.pipe(v.array(v.pipe(v.string(), v.uuid())), v.maxLength(50)),
    ]),
  ),
  query: v.optional(v.pipe(v.string(), v.maxLength(200))),
  cursor: v.optional(v.pipe(v.string(), v.maxLength(256))),
  limit: v.optional(v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(100)), 50),
});

export const vListMyJournalResponse = vJournalListResponseDto;

export const vGetJournalEntryPath = v.object({
  entryId: v.pipe(v.string(), v.uuid()),
});

export const vGetJournalEntryResponse = vJournalEntryDto;

export const vRemoveQuoteThoughtPath = v.object({
  quoteId: v.pipe(v.string(), v.uuid()),
});

export const vRemoveQuoteThoughtQuery = v.object({
  expectedVersion: v.pipe(v.number(), v.integer(), v.minValue(1)),
});

export const vRemoveQuoteThoughtResponse = vRemoveQuoteThoughtResponseDto;

export const vUpdateQuoteThoughtBody = vUpdateQuoteThoughtRequestDto;

export const vUpdateQuoteThoughtPath = v.object({
  quoteId: v.pipe(v.string(), v.uuid()),
});

export const vUpdateQuoteThoughtResponse = vQuoteThoughtDto;

export const vGetBookCommunityFeedbackPath = v.object({
  bookId: v.pipe(v.string(), v.uuid()),
});

export const vGetBookCommunityFeedbackQuery = v.object({
  language: v.optional(v.string()),
});

export const vGetBookCommunityFeedbackResponse = vBookCommunityFeedbackDto;

export const vGetMyBookFeedbackPath = v.object({
  relationId: v.pipe(v.string(), v.uuid()),
});

export const vGetMyBookFeedbackResponse = vUserBookFeedbackDto;

export const vRemoveMyBookRatingPath = v.object({
  relationId: v.pipe(v.string(), v.uuid()),
});

export const vRemoveMyBookRatingResponse = vRemoveFeedbackResponseDto;

export const vSetMyBookRatingBody = vSetRatingRequestDto;

export const vSetMyBookRatingPath = v.object({
  relationId: v.pipe(v.string(), v.uuid()),
});

export const vSetMyBookRatingResponse = vUserBookRatingDto;

export const vRemoveMyBookReviewPath = v.object({
  relationId: v.pipe(v.string(), v.uuid()),
});

export const vRemoveMyBookReviewResponse = vRemoveFeedbackResponseDto;

export const vSetMyBookReviewBody = vSetReviewRequestDto;

export const vSetMyBookReviewPath = v.object({
  relationId: v.pipe(v.string(), v.uuid()),
});

export const vSetMyBookReviewResponse = vUserBookReviewDto;

export const vGetMyCabinetLayoutResponse = vCabinetLayoutDocumentDto;

export const vSaveMyCabinetLayoutBody = vSaveCabinetLayoutRequestDto;

export const vSaveMyCabinetLayoutResponse = vCabinetLayoutDocumentDto;

export const vGetMyLibraryLayoutResponse = vLibraryLayoutDocumentDto;

export const vSaveMyLibraryLayoutBody = vSaveLibraryLayoutRequestDto;

export const vSaveMyLibraryLayoutResponse = vLibraryLayoutDocumentDto;

export const vGetMyLibraryInventoryResponse = vLibraryInventoryResponseDto;

export const vGetMyLibraryResourceCatalogueQuery = v.object({
  capabilities: v.optional(v.array(v.string())),
  appBuild: v.pipe(v.number(), v.minValue(1), v.maxValue(2147483647)),
});

export const vGetMyLibraryResourceCatalogueResponse = vLibraryResourceCatalogueResponseDto;

export const vGetMyThemeStateResponse = vReaderThemeStateDto;

export const vGetMyThemePackCatalogueQuery = v.object({
  capabilities: v.optional(v.array(v.string())),
  appBuild: v.pipe(v.number(), v.minValue(1), v.maxValue(2147483647)),
});

export const vGetMyThemePackCatalogueResponse = vThemePackCatalogueResponseDto;

export const vSaveMyThemePreferenceBody = vSaveThemePreferenceRequestDto;

export const vSaveMyThemePreferenceResponse = vReaderThemeStateDto;

/**
 * The original Goodreads CSV bytes
 */
export const vPrepareGoodreadsImportBody = v.string();

export const vPrepareGoodreadsImportHeaders = v.object({
  'Idempotency-Key': v.pipe(
    v.string(),
    v.minLength(8),
    v.maxLength(200),
    v.regex(/^[A-Za-z0-9._:-]+$/),
  ),
});

export const vPrepareGoodreadsImportQuery = v.object({
  mode: v.optional(v.picklist(['background'])),
});

export const vPrepareGoodreadsImportResponse = vGoodreadsImportPlanDto;

export const vGetCurrentGoodreadsImportResponse = vCurrentGoodreadsImportResponseDto;

export const vGetGoodreadsImportProgressPath = v.object({
  importId: v.pipe(v.string(), v.uuid()),
});

export const vGetGoodreadsImportProgressResponse = vGoodreadsImportProgressDto;

export const vResumeGoodreadsImportPath = v.object({
  importId: v.pipe(v.string(), v.uuid()),
});

export const vResumeGoodreadsImportResponse = vGoodreadsImportProgressDto;

export const vCancelGoodreadsImportPath = v.object({
  importId: v.pipe(v.string(), v.uuid()),
});

export const vCancelGoodreadsImportResponse = vCancelGoodreadsImportResponseDto;

export const vGetGoodreadsImportPath = v.object({
  importId: v.pipe(v.string(), v.uuid()),
});

export const vGetGoodreadsImportResponse = vGoodreadsImportPlanDto;

export const vApplyGoodreadsImportBody = vApplyGoodreadsImportRequestDto;

export const vApplyGoodreadsImportPath = v.object({
  importId: v.pipe(v.string(), v.uuid()),
});

export const vApplyGoodreadsImportQuery = v.object({
  mode: v.optional(v.picklist(['background'])),
});

export const vApplyGoodreadsImportResponse = v.union([
  vGoodreadsImportResultDto,
  vGoodreadsImportApplyProgressDto,
]);
